function variant_Desc(cur_varaint) {
    var _wrappers = $('.pdp_gallery_wpr');
    var _target = cur_varaint ? _wrappers.filter('.variant_' + cur_varaint) : $();
    if (_target.length) {
        _wrappers.hide();
        _target.show();
    } else {
        _wrappers.show();
    }

    setTimeout(function() {
        var configs = [
            { slider: '.pdp_gallery_slider1', thumbs: '.pdp_gallery_thumbs1', sarrow: '.gallery-slider_arrow1', tarrow: '.gallery-thumbs_arrow1', pag: '.pdp_gallery_pagition1' },
            { slider: '.pdp_gallery_slider2', thumbs: '.pdp_gallery_thumbs2', sarrow: '.gallery-slider_arrow2', tarrow: '.gallery-thumbs_arrow2', pag: '.pdp_gallery_pagition2' },
            { slider: '.pdp_gallery_slider3', thumbs: '.pdp_gallery_thumbs3', sarrow: '.gallery-slider_arrow3', tarrow: '.gallery-thumbs_arrow3', pag: '.pdp_gallery_pagition3' },
            { slider: '.pdp_gallery_slider4', thumbs: '.pdp_gallery_thumbs4', sarrow: '.gallery-slider_arrow4', tarrow: '.gallery-thumbs_arrow4', pag: '.pdp_gallery_pagition4' },
            { slider: '.pdp_gallery_slider5', thumbs: '.pdp_gallery_thumbs5', sarrow: '.gallery-slider_arrow5', tarrow: '.gallery-thumbs_arrow5', pag: '.pdp_gallery_pagition5' }
        ];
        configs.forEach(function(c) {
            var sliderEl = document.querySelector(c.slider);
            var thumbsEl = document.querySelector(c.thumbs);
            if (!sliderEl) return;
            // If already initialized and visible, just update
            if (sliderEl.swiper) {
                sliderEl.swiper.update();
                if (thumbsEl && thumbsEl.swiper) thumbsEl.swiper.update();
                return;
            }
            // Only init if the element is visible
            if ($(sliderEl).closest('.pdp_gallery_wpr').is(':visible')) {
                var P_thumbs = thumbsEl ? new Swiper(c.thumbs, {
                    slidesPerView: 5, spaceBetween: 6, watchSlidesVisibility: true,
                    navigation: { nextEl: '.swiper-button-next.' + c.tarrow.replace('.',''), prevEl: '.swiper-button-prev.' + c.tarrow.replace('.','') },
                    breakpoints: { 992: { slidesPerView: 5 }, 768: { slidesPerView: 4, centeredSlides: false } }
                }) : null;
                new Swiper(c.slider, {
                    slidesPerView: 1,
                    navigation: { nextEl: '.swiper-button-next.' + c.sarrow.replace('.',''), prevEl: '.swiper-button-prev.' + c.sarrow.replace('.','') },
                    pagination: { el: c.pag, type: 'bullets', clickable: 'true' },
                    thumbs: P_thumbs ? { swiper: P_thumbs } : undefined
                });
            }
        });
    }, 100);

    var cur_var = $('.pdp_pack_list').find('.pdp_pack_input:checked').attr('data-var');
    $('.pdp_description_inner').hide();
    $('.sub_title').hide();
    if ($('.sub_title.' + cur_var).length > 0) {
        $('.sub_title.' + cur_var).show();
    } else {
        $('.sub_title.default_title').show();
    }
    if ($('ul.left_top_content.collapsible-panels.variant_' + cur_var).length > 0) {
        $('ul.collapsible-panels.left_top_content').hide();
        $('.pdp_description_inner.variant_' + cur_var).show();
        $('ul.collapsible-panels.left_top_content.variant_' + cur_var).show();
    } else {
        $('.pdp_description_inner.default_product').show();
        $('ul.collapsible-panels.left_top_content').hide();
        $('ul.collapsible-panels.left_top_content.default_description_product').show();
    }
    if ($('ul.left_top_content_bottom.collapsible-panels.variant_' + cur_var).length > 0) {
        $('ul.collapsible-panels.left_top_content_bottom').hide();
        $('ul.collapsible-panels.left_top_content_bottom.variant_' + cur_var).show();
    } else {
        $('ul.collapsible-panels.left_top_content_bottom').hide();
        $('ul.collapsible-panels.left_top_content_bottom.default_product').show();
    }
}


$(document).ready(function() {
    function ratingHTML() {
        const elements = document.querySelectorAll('.ruk-rating-snippet-count');

        if (elements.length > 0) {
            elements.forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("(", "").replace(")", "");
            });
        } else {
            setTimeout(function() {
                ratingHTML();
            }, 500);
        }
    }

    ratingHTML();


    var cur_u = window.location.href;
    if (cur_u.indexOf('variant=') > -1) {
        var number = cur_u.split('variant=');
        $('.pdp_pack_input[value="' + number[1] + '"]').trigger('click').parent('.pdp_pack_col').addClass('active');
        // $('.pdp_pack_col.active input').trigger('click');
        $('.product-select').val(number[1]);
    }
    /* ----- new pdp JS start ----- */



    var cur_var_load = $('.pdp_pack_list').find('.pdp_pack_input:checked').attr('data-var');
    variant_Desc(cur_var_load);
    var cur_pack_price = $('.pdp_pack_option_input:checked').length > 0 ? $('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').attr('data-pack-dis-price') : $('.add_cart_wpr').attr('data-pack-dis-price');
    var data_pack_price = $('.pdp_pack_option_input:checked').length > 0 ? $('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').attr('data-pack-price') : $('.add_cart_wpr').attr('data-pack-price');
    var dat_pack_sprice = $('.pdp_pack_option_input:checked').length > 0 ? $('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').attr('data-pack-dis-price-s') : $('.add_cart_wpr').attr('data-pack-dis-price-s');
    var data_sub_price_load = $('.pdp_pack_option_input:checked').length > 0 ? $('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').attr('data-sub-price') : $('.add_cart_wpr').attr('data-sub-price');


    if (cur_pack_price != '') {
        console.log('Innn 1: ', cur_pack_price);
        $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price').html('<span class="del_price">' + data_pack_price + '</span><span class="price">' + cur_pack_price + '</span>');
        $('.add_to_cart_btn').find('span').text(cur_pack_price);
    } else if (dat_pack_sprice) {
        console.log('Innn 2: ', dat_pack_sprice);
        $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price').html('<span class="del_price">' + data_pack_price + '</span><span class="price">' + dat_pack_sprice + '</span>');
        $('.add_to_cart_btn').find('span').text(dat_pack_sprice);
    } else {
        $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price').html('<span class="price">' + data_pack_price + '</span>');
        $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .price_main').html('<span class="del_price">' + data_pack_price + '</span><span class="price">' + data_sub_price_load + '</span>');
        $('.add_to_cart_btn').find('span').text(data_pack_price);
    }

    if (parseInt($('.pdp_pack_option_input:checked').val()) == 1) {
        $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').removeClass('unavailable_subscribe');
        if ($('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save:not(.hideVariant_ubscription):not(.unavailable_subscribe) .pdp_drop_radio').length) {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .pdp_drop_radio').trigger('click');
            $('.pdp_drop_info').slideDown('slow');
        } else {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio').trigger('click');
        }
        $('.add_to_cart_btn').addClass('has_subscription')
    } else {
        $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').addClass('unavailable_subscribe');
        // $('.pdp_drop_info').slideUp('slow');
        $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio').trigger('click');
        $('.add_to_cart_btn').removeClass('has_subscription')
    }
    if ($('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .pdp_drop_radio').is(':checked')) {
        $('.add_to_cart_btn').find('span').text($('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').attr('data-sub-price'));
    }
    if ($('.pdp_pack_list .pdp_pack_col').length == 1) {
        $('.pdp_pack_list').addClass('pdp_pack_list_single');
    }


    // Pack input change
    $('body').on('change', '.pdp_pack_option_wpr .pdp_pack_option_input', function(e) {
        e.preventDefault();
        var mprice = $(this).parent('.pdp_pack_option_col').attr('data-pack-price');
        var cprice = $(this).parent('.pdp_pack_option_col').attr('data-pack-dis-price');
        var sprice = $(this).parent('.pdp_pack_option_col').attr('data-pack-dis-price-s');

        var cprices = cprice.replace('$', '');
        cprices = parseFloat(cprices);

        var sprice_s = sprice.replace('$', '');
        sprice_s = parseFloat(sprice_s);

        var data_sub_price = $(this).parent('.pdp_pack_option_col').attr('data-sub-price');

        if (cprice) {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price').html('<span class="del_price">' + mprice + '</span><span class="price">' + cprice + '</span>');
            $('.add_to_cart_btn').find('span').text(cprice);
        } else if (sprice) {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price').html('<span class="del_price">' + mprice + '</span><span class="price">' + sprice + '</span>');
            $('.add_to_cart_btn').find('span').text(sprice);
        } else {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price').html('<span class="price">' + mprice + '</span>');
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .price_main').html('<span class="del_price">' + mprice + '</span><span class="price">' + data_sub_price + '</span>');
            $('.add_to_cart_btn').find('span').text(mprice);
        }

        var data_t = parseFloat($('.pdp_pack_option_wpr').attr('data-thresh'));

        if (cprices) {
            var cprices_d = cprices;
            var g_price = cprices;
            var p_g_price = cprices;
        } else if (sprice_s) {
            var cprices_d = sprice_s;
            var g_price = sprice_s;
            var p_g_price = sprice_s;
        } else {
            var cprices_d = mprice.replace('$', '');
            cprices_d = parseFloat(cprices_d);

            data_sub_price = data_sub_price.replace('$', '');
            data_sub_price = parseFloat(data_sub_price);

            var g_price = data_sub_price;
            var p_g_price = cprices_d;
        }

        if (cprices_d > data_t) {
            $(this).parents('.pdp_pack_option_col').find('.pdp_pack_option_value').find('.pack_free_shipping').show();
        } else {
            $(this).parents('.pdp_pack_option_col').find('.pdp_pack_option_value').find('.pack_free_shipping').hide();
        }
        var gummies = $(this).parent('.pdp_pack_option_col').find('.gummies_count').attr('data-gummies');
        if (parseInt($(this).val()) == 1) {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').removeClass('unavailable_subscribe');
            if ($('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save:not(.hideVariant_ubscription):not(.unavailable_subscribe) .pdp_drop_radio').length) {
                $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .pdp_drop_radio').trigger('click');
                $('.pdp_drop_info').slideDown('slow');
            } else {
                $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio').trigger('click');
                // $('.pdp_drop_info').slideUp('slow');
            }
            $('.add_to_cart_btn').addClass('has_subscription');

            g_price = parseFloat(g_price) / gummies;
            g_price = g_price.toFixed(2);
            $(this).parent('.pdp_pack_option_col').find('.gummies_count').text('$' + g_price + ' / Gummy');

            p_g_price = parseFloat(p_g_price) / gummies;
            p_g_price = p_g_price.toFixed(2);
            $(this).closest('form').find('.pdp_drop_slide_wpr.buy_once').find('.gummies_count').text('$' + p_g_price + ' / Gummy');
        } else {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').addClass('unavailable_subscribe');
            // $('.pdp_drop_info').slideUp('slow');
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio').trigger('click');
            $('.add_to_cart_btn').removeClass('has_subscription');

            g_price = parseFloat(g_price) / gummies;
            g_price = g_price.toFixed(2);
            $(this).parent('.pdp_pack_option_col').find('.gummies_count').text('$' + g_price + ' / Gummy');

            p_g_price = parseFloat(p_g_price) / gummies;
            p_g_price = p_g_price.toFixed(2);
            $(this).closest('form').find('.pdp_drop_slide_wpr.buy_once').find('.gummies_count').text('$' + p_g_price + ' / Gummy');
        }
    });




    // Tab input change
    $('body').on('change', '.pdp_drop_main .pdp_drop_radio', function(e) {
        var gummies = $('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').find('.gummies_count').attr('data-gummies');
        if ($(this).parents('.pdp_drop_slide_wpr').hasClass('buy_once')) {
            //$('.pdp_drop_info').slideUp('slow');   
            var cur_price = $(this).parents('.pdp_drop_slide_wpr').find('.pdp_drop_price').find('.price').text();
            $('.add_to_cart_btn').removeClass('has_subscription').find('span').text(cur_price);

            var g_price = cur_price.replace('$', '');
            g_price = parseFloat(g_price) / gummies;
            g_price = g_price.toFixed(2);
            $('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').find('.gummies_count').text('$' + g_price + ' / Gummy');
            $('.pdp_pack_option_wpr').slideDown('slow');
        } else {
            //$('.pdp_drop_info').slideDown('slow');
            var cur_price = $(this).parents('.pdp_drop_slide_wpr').find('.pdp_drop_price').find('.price').text();
            $('.add_to_cart_btn').addClass('has_subscription').find('span').text(cur_price);

            var g_price = cur_price.replace('$', '');
            g_price = parseFloat(g_price) / gummies;
            g_price = g_price.toFixed(2);
            $('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').find('.gummies_count').text('$' + g_price + ' / Gummy');
            $('.pdp_pack_option_wpr').slideUp('slow');
        }
    });

    // New pdp add to cart

    //  $('body').on('click', 'button.pdp_primary.add_to_cart_btn', function(e) {
    //   e.preventDefault();

    //   var data = $(this).closest('form').serializeArray(); 

    //   if ($(this).hasClass('has_subscription')) {
    //     data.push({
    //       name: "selling_plan",
    //       value: $(this).closest('form').find('[name=selling_plan_id]').val()
    //     });
    //   }

    //   $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: data,
    //     dataType: 'json',
    //     error: function(jqXHR, textStatus, errorThrown) {
    //       var response = $.parseJSON(jqXHR.responseText);
    //       console.log(response);
    //     },
    //     success: function(data) {
    //       if (window.cartMini) {
    //         cartMini.refresh();
    //         setTimeout(function() {
    //           cartMini.open();
    //         }, 100);
    //       } else {
    //         console.warn("cartMini is not defined");
    //       }
    //     }
    //   });
    // });

    $('body').on('click', 'button.pdp_primary.add_to_cart_btn', function(e) {
        e.preventDefault();
        var _this0 = this;
        var data = $(this).closest('form').serializeArray();
        if ($(this).hasClass('has_subscription')) {
            var data = $(this).closest('form').serializeArray();
            data.push({
                name: "selling_plan",
                value: $(this).closest('form').find('[name=selling_plan_id]').val()
            });
        } else {
            var data = $(this).closest('form').serializeArray();
        }

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            error: function(jqXHR, textStatus, errorThrown) {
                var response = $.parseJSON(jqXHR.responseText);
                console.log(response);
            },
            success: function success(data) {
                console.log('data: ', data)
                console.log("Value at line 408:", _this0.cartMini);

                _this0.cartMini.refresh();
                setTimeout(function() {
                    _this0.cartMini.open();
                }, 100);
            }
        });
    });


    /* ----- new pdp js end ----- */


    if ($('.template-product .option-values .option-value').length == 1) {
        $('.template-product .option-values .option-value').addClass('has_single_option');
        $('.template-product .option-values').addClass('has_single_option_main');
        $('.template-product .option-header').addClass('has_single_option_header');
        $('.template-product .subscription_inner').addClass('has_single_subscription_inner');
    }
});

if ($('#graph-section').length >= 1) {

    //------------------------///
    function $$(selector, context) {
        context = context || document;
        var elements = context.querySelectorAll(selector);
        return Array.prototype.slice.call(elements);
    }

    function show_chart() {
        $('.stat--productivity .pie').forEach(function(pie) {
            var percents = pie.textContent.split(",");
            percents = percents.map(function(pct, idx) {
                return {
                    value: parseFloat(pct),
                    sum: 0,
                    idx: idx + 1
                }
            });
            for (var i = 0; i < percents.length; i++) {
                var prevSum = (i > 0) ? percents[i - 1].sum : 1;
                percents[i].sum = prevSum + percents[i].value;
            };
            percents.reverse();
            var NS = "http://www.w3.org/2000/svg";
            var svg = document.createElementNS(NS, "svg");
            pie.textContent = ''; //clear div
            svg.setAttribute("viewBox", "0 0 32 32");
            pie.appendChild(svg);
            percents.forEach(function(pct, idx) {
                var circle = document.createElementNS(NS, "circle");
                circle.classList.add("circle" + pct.idx);
                circle.setAttribute("r", 16);
                circle.setAttribute("cx", 16);
                circle.setAttribute("cy", 16);
                circle.setAttribute("stroke-dasharray", "0 100");
                setTimeout(function() {
                    circle.setAttribute("stroke-dasharray", pct.sum + " 100");
                });
                svg.appendChild(circle);
            });
            percents.forEach(function(pct, idx) {
                var digit = document.createElement("span");
                digit.textContent = pct.value + " %";
                digit.classList.add("label" + (idx + 1));
                pie.appendChild(digit);
            });
        });
    }
    //------------------------///


    show_chart();
    $(window).on('load scroll', function() {
        var $e = $('#graph-section');
        $e.removeClass("active")

        $e.each(function(index) {

            var $window = $(window);
            var docViewTop = $window.scrollTop();
            var docViewBottom = docViewTop + 20 + $window.height();
            var elemTop = $e.eq(index).offset().top;
            var elemBottom = elemTop - $e.eq(index).height();

            if (elemTop > docViewTop && elemBottom < docViewBottom) {
                if ($('#graph-section').hasClass('show') == false) {
                    $('#graph-section').addClass('show');
                    show_chart();
                }
            } else {
                $('#graph-section').removeClass('show');
            }
        });
    });

}
/*----------popup----------*/
window.popup = (function() {
    function Popup(args) {
        if (typeof args !== 'undefined') {
            //if 'click to open' selector is undefined, return with the info in console
            if (typeof args.clickToOpen === 'undefined') {
                // console.log('"clickToOpen" param is not defined.'); 
                return;
            }

            //if the element coresponds to 'clickToOpen' selector is undefined, return with info in console
            if (!document.querySelector(args.clickToOpen)) {
                // console.log('The element associated with "clickToOpen" param is not defined.'); 
                return;
            }

            //if 'click to open' selector is defined but 'data-trigger-popup' is undefined, return with the info in console.
            if (typeof document.querySelector(args.clickToOpen).dataset.triggerPopup === 'undefined' || document.querySelector(args.clickToOpen).dataset.triggerPopup == '') {
                // console.log('"data-trigger-popup" attribute of "clickToOpen" selector is not properly defined.');
                return;
            }

            //set argument params
            args.container = document.querySelector(args.clickToOpen).dataset.triggerPopup;
            args.clickToClose = (typeof args.clickToClose !== 'undefined') ? args.clickToClose : '.popup-close';
            args.setCookieToHide = (typeof args.setCookieToHide === 'boolean') ? args.setCookieToHide : false;
            args.delay = (typeof args.delay === 'number' && args.delay > 0) ? args.delay : false;
        } else {
            //if no arg params present, return with info in console
            // console.log('Both "clickToOpen" selector and its "data-trigger-popup" attribute have to be properly defined'); 
            return;
        }
        //config params
        this.args = args;
        //init popup
        this.init();
    }
    Popup.prototype.init = function() {
        var $container = document.querySelector(this.args.container);
        var _this = this;
        //if container element is not defined, return with info in console
        if (!$container) {
            // console.log('container element is not defined'); 
            return;
        }
        this.$container = $container;
        //trigger popup on click.
        document.querySelector(this.args.clickToOpen).addEventListener('click', function(e) {
            e.preventDefault();
            //close mobile menu
            if (this.classList.contains('mobile')) {
                document.querySelector('.mobile-dropdown--close').click();
            }
            //call 'open' function
            _this.open();
        });
        //get the elements to close popup
        var $clickToCloseElements = this.$container.querySelectorAll(this.args.clickToClose);
        for (var i = 0; i < $clickToCloseElements.length; i++) {
            //close popup on click
            $clickToCloseElements[i].addEventListener('click', function(e) {
                e.preventDefault();
                _this.close();
            });
        }
        //close popup when someone clicks on overlay
        this.$container.querySelector('.popup-overlay') && this.$container.querySelector('.popup-overlay').addEventListener('click', function() {
            _this.close();
        });
        //check if cookie is used to show/hide the popup
        if (this.args.setCookieToHide) {
            var popupCookieName = (typeof this.$container.dataset.cookieName !== 'undefined' || this.$container.dataset.cookieName == '') ? this.$container.dataset.cookieName : 'popup' + this.args.clickToOpen;
            var popupCookieInterval = (typeof this.$container.dataset.cookieInterval !== 'undefined' || this.$container.dataset.cookieInterval == '') ? parseInt(this.$container.dataset.cookieInterval) : 7;
            //set current cookie name and interval
            this.cookieName = popupCookieName;
            this.cookieInterval = popupCookieInterval;
            var currentCookieVal = this.getCookie(popupCookieName);
            if (currentCookieVal == false) {
                setTimeout(function() {
                    document.querySelector(_this.args.clickToOpen).click();
                }, 100);
            }
        }
    };
    Popup.prototype.open = function() {
        //if cookie is used to show/hide popup, clear the cookie before openning

        this.previousFocusedElement = document.activeElement;

        if (this.args.setCookieToHide && this.cookieName) {
            this.setCookie(this.cookieName, '', -1);
        }
        //Entire popup layout is css controlled so all we need to do is add the class 'popup-active'
        if (this.args.delay) {
            var _this = this;
            setTimeout(function() {
                _this.$container.classList.add('popup-active');
            }, _this.args.delay);
        } else {
            this.$container.classList.add('popup-active');
            this.$container.setAttribute('aria-hidden', 'false');
            this.$container.focus();
        }

        var _this = this; // Capture the context
        document.addEventListener('keydown', function handleEscapeKey(event) {
            if (event.key === 'Escape' || event.keyCode === 27) {
                if (_this.$container.classList.contains('popup-active')) {
                    _this.close();
                }
            }
        });
    };
    Popup.prototype.close = function() {
        //Entire popup layout is css controlled so all we need to do is remove the class 'popup-active'
        this.$container.classList.remove('popup-active');
        this.$container.setAttribute('aria-hidden', 'true');

        if (this.previousFocusedElement) {
            this.previousFocusedElement.focus();
        }

        //if cookie is used to show/hide popup, set cookie once user closes the popup
        if (this.args.setCookieToHide && this.cookieName && this.cookieInterval) {
            this.setCookie(this.cookieName, 'disabled', this.cookieInterval);
        }
        //console.log(this.getCookie(this.cookieName));
    };
    Popup.prototype.setCookie = function(cookieName, cookieVal, cookieInterval) {
        var date = new Date();
        date.setTime(date.getTime() + (cookieInterval * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = cookieName + "=" + cookieVal + ";" + expires + ";SameSite=Lax;path=/";
    }
    Popup.prototype.getCookie = function(cookieName) {
        var cookieTermString = cookieName + "=";
        var cookieArray = document.cookie.split(';');
        for (var i = 0; i < cookieArray.length; i++) {
            var cookieItem = cookieArray[i];
            while (cookieItem.charAt(0) == ' ') {
                cookieItem = cookieItem.substring(1);
            }
            if (cookieItem.indexOf(cookieTermString) == 0) {
                return cookieItem.substring(cookieTermString.length, cookieItem.length);
            }
        }
        return false;
    }
    return Popup;
})();
/*----------Newsletter popup--------*/
new popup({
    clickToOpen: '.newsletter-popup-open',
    setCookieToHide: true,
    delay: 30000
});
new popup({
    clickToOpen: '[data-newsletter-popup-link]',
    setCookieToHide: false
});
new popup({
    clickToOpen: '[data-newsletter-popup-link-mobile]',
    setCookieToHide: false
});
/*--------Doctor profile popup---------*/
var $profilePopups = document.querySelectorAll('.profile-popup-open');
for (var i = 0; i < $profilePopups.length; i++) {
    var blockId = $profilePopups[i].dataset.blockId;
    var selector = '.profile-popup-open-' + blockId;
    new popup({
        clickToOpen: selector,
        setCookieToHide: false,
        onOpen: function() {
            var popupElement = document.querySelector(selector);

            if (popupElement) {
                popupElement.setAttribute('tabindex', '-1');
                popupElement.focus();
            }
        },
        onClose: function() {
            $profilePopups[i].focus();
        }
    });
}
/*------product grid item equal height-------*/
var equalizeCardDetailsHeight = function() {
    var $gridItems = document.querySelectorAll('.product-list');
    for (var i = 0; i < $gridItems.length; i++) {

        // Cache the highest
        var highestBox = 0;

        // Select and loop the elements you want to equalise
        var $detailsBoxitems = $gridItems[i].querySelectorAll('.product-card-details');
        for (var j = 0; j < $detailsBoxitems.length; j++) {
            //remove initial height set with style attribute 
            $detailsBoxitems[j].style.removeProperty("height");
            // If this box is higher than the cached highest then store it
            if ($detailsBoxitems[j].clientHeight > highestBox) {
                highestBox = $detailsBoxitems[j].clientHeight + 20;
            }

        }
        //console.log(highestBox);
        // Set the height of all those children to whichever was highest 
        for (var k = 0; k < $detailsBoxitems.length; k++) {
            $detailsBoxitems[k].style.height = highestBox + 'px';
        }
    }
}
equalizeCardDetailsHeight();
window.onresize = function() {
    equalizeCardDetailsHeight();
}
/*--------infinite scroll-------*/
window.infiniteScrollPagination = (function() {
    function InfiniteScrollPagination(args) {
        var args = args || {};
        args.paginationSelector = args.paginationSelector || '.ajax-pagination';
        args.container = args.container || '.ajax-grid-items';
        this.args = args;
        this.init();
    }
    InfiniteScrollPagination.prototype.init = function() {
        if (!document.querySelector(this.args.container) || !document.querySelector(this.args.paginationSelector)) return;
        var _this = this;
        window.addEventListener('scroll', function(e) {
            var $container = document.querySelector(_this.args.container);
            var $paginationEl = document.querySelector(_this.args.paginationSelector);
            if (!$paginationEl) return;
            var nextPageUrl = $paginationEl.getAttribute('href');
            var windowTop = window.pageYOffset || document.documentElement.scrollTop;
            var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            var windowBottom = windowTop + windowHeight;
            var containerBottom = $container.offsetTop + $container.clientHeight;
            if (windowBottom > containerBottom && !$paginationEl.classList.contains('loading')) {
                $paginationEl.classList.add('loading');
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", nextPageUrl, true);
                xhttp.responseType = "document";
                xhttp.send();
                xhttp.onreadystatechange = function() {
                    if (this.readyState == 4 && this.status == 200) {
                        var $resCont = this.response.querySelector(_this.args.container);
                        var $resPageEl = this.response.querySelector(_this.args.paginationSelector);
                        $container.innerHTML += $resCont.innerHTML;
                        if ($resPageEl) {
                            $paginationEl.parentNode.replaceChild($resPageEl, $paginationEl);
                        } else {
                            $paginationEl.parentNode.removeChild($paginationEl);
                        }
                        return false;
                    }
                };
            }
        });
    }
    return InfiniteScrollPagination;
})();
new infiniteScrollPagination();

function addToCartSuccess_free() {
    $.get("/cart?view=mini", function(data) {
        $('.cart-mini-content').html($(data).find('div[data-cart-mini-content]').html());
        $('.cart-mini-footer').html($(data).find('div[data-cart-mini-footer]').html());
    });
}
/*------Quantity plus/minus option on product and cart page-------*/
/*function miniCartQtyChange(e){
    var $qtyInput = e.target.parentNode.querySelector('input[type="number"]');
    var qty = parseInt($qtyInput.value);
  	var itemKey = $qtyInput.dataset.itemKey;
    if(e.target.classList.contains('qty-plus')){
      qty += 1;
    } else if(e.target.classList.contains('qty-minus')){     
        qty = qty > 0 ? (qty - 1) : 0;
    }
    $qtyInput.value = qty;
    if(qty == 0){
      document.querySelector('[data-cart-mini-item-remove="'+itemKey+'"]').click(); return;
    }
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {    
          var cartData = JSON.parse(this.response);
          for(var i=0; i<cartData.items.length; i++){
          	 $('[data-item="cart-mini-item-price-'+cartData.items[i].key+'"]').html(Shopify.formatMoney(cartData.items[i].final_line_price));
          }


          if($('.free-shiping-line').length > 0 ){
            var price_ship = '6500';
            var less = parseInt(price_ship)-parseInt(cartData.total_price);

            var total = parseInt(cartData.total_price/100);
            var lll = (total*10000)/parseInt(price_ship);

            if(cartData.total_price > parseInt(price_ship)){
              var free_ship = 'Your order qualifies for <b>FREE USA shipping</b>!';
              document.querySelector('.free-shiping-line p').innerHTML = free_ship;
              $('.progress-bar .fill-progress-bar').css('width','100%');
            }else{
              var free_ship_msg = 'You’re <span>x</span> away from <strong>FREE USA shipping</strong>!';
              var f = free_ship_msg.replace("x",Shopify.formatMoney(less));
              document.querySelector('.free-shiping-line p').innerHTML = f;
              $('.progress-bar .fill-progress-bar').css('width',lll+'%');
            }
          }

          if($('#gift_product_avi').length){
            var add_remove_id = parseInt($('#gift_product_avi').attr('data-gift'));
            var price_fix = parseInt($('#gift_product_avi').attr('data-gift-price')) * 100;

            var check_gift = 0;
            $(cartData.items).each(function(ii,vv){
              if(vv.id == add_remove_id){
                check_gift = 1;
              }
            });

            function total_amout(){
              $.getJSON('/cart.js', function(cart){
                document.querySelector('.cart-mini-subtotal-value').innerText = Shopify.formatMoney(cart.total_price);
                document.querySelector('[data-cart-mini-count]').innerText = cart.item_count;
              }); 
            }
            console.log(check_gift + '  check_gift');
            if(cartData.total_price < price_fix){
              if(check_gift == 1){
                Shopify.changeItem(add_remove_id,0, function(c){
                  console.log('item removed');
                   $.get( "/cart?view=mini", function( data ) {
                   $('.cart-mini-content').html($(data).find('template[data-html]').html());
                    $('.cart-mini-footer').html($(data).find('div[data-cart-mini-footer]').html());
                  });
                  total_amout();
                });
              }else{
               total_amout(); 
              }
            }else{
              if(check_gift == 0){
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: { id: add_remove_id, quantity: 1 },
                  dataType: 'json',
                  error: function(jqXHR, textStatus, errorThrown){
                    var response = $.parseJSON(jqXHR.responseText);
                    console.log(response);
                  }
                }).done(function( data ) {
                  $.get( "/cart?view=mini", function( data ) {
                    $('.cart-mini-content').html($(data).find('template[data-html]').html());
                    $('.cart-mini-footer').html($(data).find('div[data-cart-mini-footer]').html());
                  });
                  total_amout();
                });
              }else{
               total_amout(); 
              }
            }
          }
        }
      };
      xhttp.open("POST", "/cart/change.js", true);
      xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      xhttp.send("quantity="+qty+"&id="+$qtyInput.dataset.itemKey);   
}*/
var $qtyChangeSelectors = document.querySelectorAll('span.qty-change');
for (var i = 0; i < $qtyChangeSelectors.length; i++) {
    $qtyChangeSelectors[i].addEventListener('click', function() {
        var $qtyInput = this.parentNode.querySelector('input[type="number"]');
        var qty = parseInt($qtyInput.value);
        var isInCart = $qtyInput.classList.contains('cart-item-quantity') ? true : false;
        if (this.classList.contains('qty-plus')) {
            qty += 1;
        } else if (this.classList.contains('qty-minus')) {
            if (isInCart) {
                qty = qty > 0 ? (qty - 1) : 0;
            } else {
                qty = qty > 1 ? (qty - 1) : 1;
            }
        }
        $qtyInput.value = qty;
        if (isInCart) {
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    if ($qtyInput.classList.contains('in-cart-template')) {
                        location.reload();
                    } else {
                        console.log('in cart modal');
                    }
                }
            };
            xhttp.open("POST", "/cart/change.js", true);
            xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhttp.send("quantity=" + qty + "&id=" + $qtyInput.dataset.itemKey);

        }
    });
}

/*------add class to mak header static in order to push announcement bar below------*/
function addStaticHeaderClass() {
    var windowTop = window.pageYOffset || document.documentElement.scrollTop;
    if (windowTop == 0) {
        if ($('.new-header').length > 0) {
            document.querySelector('#shopify-section-alt-header').classList.add('header--static');
        } else {
            document.querySelector('#shopify-section-static-header').classList.add('header--static');
        }
        document.querySelector('.page-body-content').classList.add('no-top-margin');
    } else {
        if ($('.new-header').length > 0) {
            document.querySelector('#shopify-section-alt-header').classList.remove('header--static');
        } else {
            document.querySelector('#shopify-section-static-header').classList.remove('header--static');
        }
        document.querySelector('.page-body-content').classList.remove('no-top-margin');
    }
}
window.onscroll = function() {
    addStaticHeaderClass();
};
addStaticHeaderClass();
/*-----Smooth scroll function------*/
// window.smoothScroll = (function(){
//   function SmoothScroll(args){
//     if(typeof args !== 'object'){
//       //if parameters are not defined return with info in console
//       console.log('parameters not definied.')
//       return;
//     } else {
//       //if destination not defined return with info in console
//       if(typeof args.destination === 'undefined'){
//         console.log('destination not defined'); 
//         return;
//       }
//       args.duration = (typeof args.duration === 'number') ? args.duration : 500;
//       args.callback = (typeof args.callback === 'function') ? args.callback : false;
//     }
//     this.args = args;
//     this.init();
//   }
//   SmoothScroll.prototype.init = function(){
//     var startPosition = window.pageYOffset;
//     var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
//     var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight,document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
//     var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
//     var destinationOffset = typeof this.args.destination === 'number' ? this.args.destination : this.args.destination.offsetTop;
//     var destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);
// 	var duration = this.args.duration;
//     var callback = this.args.callback;
//     //in case of no 'requestAnimationFrame'
//     if ('requestAnimationFrame' in window === false) {
//       window.scroll(0, destinationOffsetToScroll);
//       //call the callback function
//       if (this.args.callback) {
//         this.args.callback();
//       }
//       return;
//     }

//     //scroll function for using 'requestAnimationFrame'
//     function scroll() {
//       var now = 'now' in window.performance ? performance.now() : new Date().getTime();
//       var time = Math.min(1, ((now - startTime) / duration));
//       window.scroll(0, Math.ceil((time * (destinationOffsetToScroll - startPosition)) + startPosition));

//       if (window.pageYOffset >= (destinationOffsetToScroll - 10)) {
//         //console.log('scroll end');
//         //call the callback function
//         if (callback) {
//           callback();
//         }
//         return;
//       } else {
//         requestAnimationFrame(scroll);
//       }
//     }
//     scroll();
//   }

//   return SmoothScroll;
// })();
/*-----Glossary page smooth scroll-----*/
var $chSelector = document.querySelectorAll('.characters a');
for (var i = 0; i < $chSelector.length; i++) {
    $chSelector[i].addEventListener('click', function(e) {
        e.preventDefault();
        var $scrollToSelector = document.querySelector(this.getAttribute('href'));
        var elemOffsetTop = $scrollToSelector.offsetTop;
        if (document.querySelector('.main-header--minimal-sticky')) {
            elemOffsetTop -= document.querySelector('.main-header--minimal-sticky').clientHeight;
        }
        //     window.scrollTo({
        //       'behavior': 'smooth',
        //       'left': 0,
        //       'top': elemOffsettop
        //     });
        jQuery("html, body").animate({
            scrollTop: elemOffsetTop
        });

    });
}
// Function to scroll to the specified section
function scrollToSection() {
    var $scrollToSelector_find = document.querySelector('#shopify-section-logo_marquee_HXHmzK, #shopify-section-template--18408319025303__logo_marquee_HXHmzK');
    if ($scrollToSelector_find) {
        var elemOffsetTop_find = $scrollToSelector_find.offsetTop;
        var stickyHeader = document.querySelector('.main-header--minimal-sticky');

        if (stickyHeader) {
            elemOffsetTop_find -= stickyHeader.clientHeight;
        }
        jQuery("html, body").animate({
            scrollTop: elemOffsetTop_find
        });
    }
}

// Check if the URL contains the specified hash and scroll to the section if it does
if (window.location.hash === "#shopify-section-logo_marquee_HXHmzK" || window.location.hash === "#shopify-section-template--18408319025303__logo_marquee_HXHmzK") {
    console.log('innn')
    scrollToSection();
}

// Add click event listener to the specific link
var $chSelector_find = document.querySelector('.cm_menu_col a[data-link="find-us"]');
if ($chSelector_find) {
    $chSelector_find.addEventListener('click', function(e) {
        scrollToSection();
    });
}


function scrollToSection_mobile() {
    var $scrollToSelector_find = document.querySelector('#shopify-section-logo_marquee_HXHmzK, #shopify-section-template--18408319025303__logo_marquee_HXHmzK');
    if ($scrollToSelector_find) {
        var elemOffsetTop_find = $scrollToSelector_find.offsetTop;
        var stickyHeader = document.querySelector('.main-header--minimal-sticky');

        if (stickyHeader) {
            elemOffsetTop_find -= stickyHeader.clientHeight;
        }
        $('.close-menu').trigger('click');
        jQuery("html, body").animate({
            scrollTop: elemOffsetTop_find
        });
    }
}

// Check if the URL contains the specified hash and scroll to the section if it does
if (window.location.hash === "#shopify-section-logo_marquee_HXHmzK") {
    console.log('innn')
    scrollToSection_mobile();
}

// Add click event listener to the specific link
var $chSelector_find_m = document.querySelector('.menu-links a[data-link="find-us"]');
if ($chSelector_find_m) {
    $chSelector_find_m.addEventListener('click', function(e) {
        scrollToSection_mobile();
    });
}


/*------Contact page tab-----*/
var $tabHeadings = document.querySelectorAll('.tabs input');
for (var i = 0; i < $tabHeadings.length; i++) {
    $tabHeadings[i].addEventListener('click', function(e) {
        e.preventDefault();
        if (this.parentNode.classList.contains('active')) {
            return;
        } else {
            this.parentNode.classList.add('active');
            document.querySelector(this.getAttribute('data-href')).classList.add('active');
            for (var j = 0; j < $tabHeadings.length; j++) {
                if (this != $tabHeadings[j]) {
                    $tabHeadings[j].parentNode.classList.remove('active');
                    document.querySelector($tabHeadings[j].getAttribute('data-href')).classList.remove('active');
                }
            }
        }
    });
}
//check if location hash contains tab name and trigger that tab
if (window.location.hash) {
    if (document.querySelector(window.location.hash) && document.querySelector('a[href="' + window.location.hash + '"]') && document.querySelector('a[href="' + window.location.hash + '"]').parentNode.classList.contains('tab-heading')) {
        var $elem = document.querySelector('a[href="' + window.location.hash + '"]');
        var elemOffsetTop = $elem.parentNode.offsetTop;
        $elem.click();
        if (document.querySelector('.main-header--minimal-sticky')) {
            elemOffsetTop -= document.querySelector('.main-header--minimal-sticky').clientHeight;
        }
        jQuery("html, body").animate({
            scrollTop: elemOffsetTop
        });
    }
}

// $('.collapsible-panel-block-heading').click(function(){
//   var slide = $(this).data('id');
//   console.log(slide);
//   if($(this).hasClass('active')){
//     console.log('aaaa');
//     $(this).removeClass('active').next('.collapsible-panel-block-content[data-slide='+slide+']').removeClass('active');
//   }else{
//     console.log('bbbb');
//     $('.collapsible-panel-block-heading').removeClass('active').next('.collapsible-panel-block-content[data-slide='+slide+']').removeClass('active');
//     $(this).toggleClass('active').next('.collapsible-panel-block-content').toggleClass('active');
//   }
// });

$(document).ready(function() {
    var current_url = window.location.href;
    if (current_url.indexOf('/shop-by-solution') != -1) {
        $('body').on('click', '.menu-accoridian ul li .sub-menu li a', function() {
            var href = $(this).attr('href');
            // console.log('@@@@@');
            if (href.indexOf('shop-by-solution#') != -1) {
                $('.menu-header .close-menu').trigger('click');
            }
        });
    }
    /*menu slide toggle js start here*/
    $('.msubmenu svg').on('click', function() {
        $(this).closest('li').toggleClass("active");
        $(this).closest('li').find('.sub-menu').slideToggle();
    })
    /*menu slide toggle js end here*/
    // Set the Campaign ID for the submission

    $('body').on("keyup", "#phone", function(e) {
        e.preventDefault();
        var value = $(this).val();
        var val = $(this).val().replace(/[^\d]/g, '');
        var phone = $(this);
        var x = true;
        if (e.key != 'Backspace') {
            if (val.length == 1) {
                val = val.replace(/(\d{1})/, "+1($1");
            } else if (val.length == 5) {
                val = val.replace(/(\d{1})(\d{3})/, "+$1($2) ");
            } else if (val.length == 7) {
                val = val.replace(/(\d{1})(\d{3})(\d{3})/, "+$1($2) $3-");
            } else if (val.length == 8) {
                val = val.replace(/(\d{1})(\d{3})(\d{3})(\d{1})/, "+$1($2) $3-$4");
            } else if (val.length > 11) {
                val = val.substring(0, 11).replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "+$1($2) $3-$4");
            } else {
                val = value;
            }
            $(this).val(val);
        }
    });

    //   document.getElementById('phone').addEventListener('keyup', function (e) {
    //     var x = e.target.value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
    //     e.target.value = '+1(' + x[1] + ') ' + x[2] + '-' + x[3];
    //     document.getElementById("phone").value = e.target.value;
    //   });

    var campaignId = 35659;
    $('#newsletter-popup-form').on('submit', function(event) {
        var phoneNumber = $('#newsletter-popup-form').find('#phone').val();
        event.preventDefault();
        var x = true;
        $(this).find('.err-msg').remove();
        $('.success-msg').hide();
        var pn = $(this).find('#phone');
        var phoneno = /^[\+][0-9]{1}[(]?[0-9]{3}[)][\s][0-9]{3}[-][0-9]{4}$/im;
        if (pn.val().trim() == '' || !phoneno.test(pn.val()) || pn.val().length < 16) {
            pn.parent().append('<p class="err-msg">Please enter valid phone number.</p>');
            x = false;
        } else {
            pn.parent().find('.err-msg').remove();
            var settings = {
                "url": "https://vyg.mobi/api/v2/subscriber",
                "method": "POST",
                "headers": {
                    "Content-Type": "application/json"
                },
                "data": JSON.stringify({
                    "phoneNumber": phoneNumber,
                    "campaignId": 35659
                }),
            };
            $.ajax(settings).done(function(response) {
                $('.success-msg').show();
            });
        }
        if (x == false) {
            return false;
        }
    });

    // Retrieve the form element by the id attribute
    //   var form = document.getElementById('newsletter-popup-form');

    //   if (form) {
    //     form.addEventListener('submit', function (event) {
    //       console.log('INnnnnnnn');
    //       // Retrieve the phone number from the field containing "phone" in name attribute
    //       var phoneField = form.querySelector('input[name~="phone"]');
    //       var phoneNumber = phoneField ? phoneField.value : '';

    //       // Optional: Prevents reloading the page if using a standard form submit.
    //       event.preventDefault();
    //       // Optional: Validate form has all correct details
    //       //         validate();


    //     });
    //   }
    //   $(".collapsible-panel-block-heading").on("click", function() {
    //     if($(this).hasClass('dblog')){
    //     if ($(this).hasClass("active")) {
    //       console.log('____');
    //       $(this).removeClass("active");
    //       $(this).siblings('.blog_filter').removeClass("active");
    //     } else {
    //       console.log('***');
    //       $(".collapsible-panel-block-heading").removeClass("active");
    //       $(this).addClass("active");
    //       $(this).siblings('.blog_filter').toggleClass('active');
    //     }
    //     }else{
    //       if ($(this).hasClass("active")) {
    //         $(this).removeClass("active");
    //         $(this).siblings(".collapsible-panel-block-content,.faq-content-wrap").removeClass("active");
    //       } else {
    //         $(".collapsible-panel-block-heading").removeClass("active");
    //         $(this).addClass("active");
    //         $(".collapsible-panel-block-content,.faq-content-wrap").removeClass("active");
    //         $(this).siblings(".collapsible-panel-block-content,.faq-content-wrap").toggleClass('active');
    //       }
    //     }

    //   });



    //   $(".dblog.collapsible-panel-block-heading").on("click", function() {

    //     if ($(this).hasClass("active")) {
    //       console.log('____');
    //       $(this).removeClass("active");
    //       $(this).siblings('.blog_filter').removeClass("active");
    //     } else {
    //       console.log('***');
    //       $(".collapsible-panel-block-heading").removeClass("active");
    //       $(this).addClass("active");
    //       $(this).siblings('.blog_filter').toggleClass('active');
    //     }
    //   });
});

// function openGlossaryItem(e){
//   if(window.location.hash){
//     if(document.querySelector(window.location.hash) && document.querySelector(window.location.hash).classList.contains('anchor-li')){
//       var $elem = document.querySelector(window.location.hash);
//       var $elemToClick = $elem.querySelector('.collapsible-panel-block-heading');
//       //console.log($elemToClick);
//       var eachGlossaryItem = document.querySelectorAll('.collapsible-panel-block-heading');
//       eachGlossaryItem.forEach(element => {
//         if(element != $elemToClick && element.classList.contains('active')){
//           element.classList.remove('active');
//           element.nextElementSibling.classList.remove('active');
//         }
//       });
//       $elemToClick.classList.toggle('active');
//       $elemToClick.nextElementSibling.classList.toggle('active');    
//       var elemOffsetTop = $elemToClick.offsetTop;
//       //console.log(elemOffsetTop+', '+window.pageYOffset+', '+$elemToClick.clientHeight);
//       if(elemOffsetTop > window.pageYOffset && window.pageYOffset > 0 && e != 'load' ){
//         elemOffsetTop -= $elemToClick.clientHeight*2;
//       }
//       if(document.querySelector('.main-header--minimal-sticky')){
//         elemOffsetTop -= document.querySelector('.main-header--minimal-sticky').clientHeight;
//       }
//       jQuery("html, body").animate({ scrollTop: elemOffsetTop });	
//     }
//   }
// }
// window.onpopstate = function(){
//   openGlossaryItem();
// };
// window.onload = function(){
//   var event = 'load';
//   openGlossaryItem(event);
// };
//product gallery arrow navigation
//var $arrowNavs = document.querySelectorAll('.product-gallery--arrow-navigation .arrow');
//var $dotsContainer = document.querySelector('[data-product-gallery-navigation]');
// for(var i=0; i<$arrowNavs.length; i++){
//   $arrowNavs[i].addEventListener('click', function(){
//     var $dots = $dotsContainer.querySelectorAll('button');
//     var dotsLength = $dots.length;
//     var $activeDot = $dotsContainer.querySelector('[data-product-gallery-selected="true"]');
//     var currentSlideindex = parseInt($activeDot.dataset.slide);
//     if(this.classList.contains('arrow-left')){
//       if(currentSlideindex == 0){
//         $dots[dotsLength-1].click();
//       } else {
//         $dots[currentSlideindex-1].click();
//       }
//     } 
//     if(this.classList.contains('arrow-right')) {
//       if(currentSlideindex == dotsLength - 1){
//         $dots[0].click();
//       } else {
//         $dots[currentSlideindex+1].click();
//       }
//     } 
//   });
// }
jQuery(function($) {
    //icon slider for mobile
    //   function mobileOnlySlider($selector, mode) {
    //     if(mode == 'slick'){
    //       $selector.slick({
    //         slidesToShow: 7,
    //         arrows: false,
    //         autoplay: true,
    //         infinite: true,
    //         speed: 1000,
    //         autoplaySpeed: 2000,
    //         responsive: [
    //           {
    //             breakpoint: 480,
    //             settings: {
    //               arrows: false,
    //               slidesToShow: 4,
    //             }
    //           }
    //         ]
    //       });
    //     } else {
    //       $selector.slick('unslick');
    //     }
    //   }
    //   if($(window).width() < 900) {
    //     console.log('in');
    // 	  mobileOnlySlider($('.marquee-logo'), 'slick');
    //   }
    //   $(window).resize(function(){
    // 	 if($(this).width() < 900) {
    //        if(!$('.marquee-logo').hasClass('slick-initialized')){
    //            mobileOnlySlider($('.marquee-logo'), 'slick');
    //        }

    //      } else {
    //        if($('.marquee-logo').hasClass('slick-initialized')){
    //                mobileOnlySlider($('.marquee-logo'), 'unslick');
    //            }
    //      }

    //   });

    /*------Product info collapsible panels-------*/
    //   var $panelHeadings = document.querySelectorAll('.collapsible-panel-block-heading');
    //   for(var i=0; i<$panelHeadings.length; i++){
    //     $panelHeadings[i].addEventListener('click', function(e){
    //       if(this.querySelector('span')){
    //         if(this.classList.contains('active')){
    //           this.querySelector('span').innerText = 'Show ';
    //         } else {
    //           this.querySelector('span').innerText = 'Hide ';
    //         }
    //       }


    //       var eachGlossaryItem = document.querySelectorAll('.collapsible-panel-block-heading');
    //       eachGlossaryItem.forEach(element => {
    //         if(element != this && element.classList.contains('active')){
    //           //$('.product-info--slider').find('.slick-list').height($('.product-info--slider').find('.slick-list').height() - element.nextElementSibling.offsetHeight);
    //           element.classList.remove('active');
    //           element.nextElementSibling.classList.remove('active');
    //         }
    //       });
    //       if(this.classList.contains('active')){
    //         //$('.product-info--slider').find('.slick-list').height($('.product-info--slider').find('.slick-list').height() - this.nextElementSibling.offsetHeight);
    //         this.classList.remove('active');
    //         this.nextElementSibling.classList.remove('active');
    //       } else {
    //         this.classList.toggle('active');
    //         this.nextElementSibling.classList.toggle('active');
    //         //$('.product-info--slider').find('.slick-list').height($('.product-info--slider').find('.slick-list').height() + this.nextElementSibling.offsetHeight);
    //       }
    //       //$('.product-info--slider').slick('resize');

    //     });
    //   }
});
$('document').ready(function() {
    $('body').on('click', '.close_this', function(e) {
        e.preventDefault();
        $(this).closest('.gift_product_wrapper').hide();
    });

    var frqncy;
    if ($(window).width() > 960) {
        $('.template-product .shiipevery.timing_selector').find('.daysinptt').attr('name', 'shipping_interval_frequency');
        $('.shiipevery-select.timing_selector').find('.days-select').attr('name', '');
        frqncy = '.shiipevery-select.timing_selector';
    } else {
        $('.template-product .shiipevery-select.timing_selector').find('.days-select').attr('name', 'shipping_interval_frequency');
        $('.template-product .shiipevery.timing_selector').find('.daysinptt').attr('name', '');
        if ($('.template-collection').length > 0) {
            frqncy = '.shiipevery.timing_selector';
        } else {
            frqncy = '.shiipevery-select.timing_selector';
        }
    }
    $('.shipevery-row #days30').trigger('click');
    $('.collection-grid-custom').each(function() {
        $(this).find('#days30').trigger('click');
    });
    // $('.timing_selector').slideUp();
    $(window).on('resize', function() {
        if ($(window).width() > 960) {
            $('.template-product .shiipevery.timing_selector').find('.daysinptt').attr('name', 'shipping_interval_frequency');
            $('.shiipevery-select.timing_selector').find('.days-select').attr('name', '');
            frqncy = '.shiipevery-select.timing_selector';
            // if($('.template-product').find('.tab-slider--trigger.check-trigger').length > 0){
            //   if($('.template-product').find('.tab-slider--trigger.check-trigger.active').attr('rel')!="tab2"){
            //     if($('.template--product .product-pack-list').length > 0){
            //       $('.template--product .product-pack-list.desk_only').slideDown('slow');
            //       $('.template--product .product-pack-list.mobile_only').hide('slow');
            //     }
            //      $('.product-form-grid-radio').find('.product-pack-list').find('.pack_list-value').removeClass('active_pack');
            //     $('.product-form-grid-radio').find('.product-pack-list.desk_only').find('.pack_list-value:first-child').addClass('active_pack').find('input').trigger('click');
            //   }
            // }

        } else {
            if ($('.template-product').find('.tab-slider--trigger.check-trigger').length > 0) {
                if ($('.template-product').find('.tab-slider--trigger.check-trigger.active').attr('rel') != "tab2") {
                    if ($('.template--product .product-pack-list').length > 0) {
                        // $('.template--product .product-pack-list.mobile_only').slideDown('slow');
                        // $('.template--product .product-pack-list.desk_only').hide('slow');
                    }
                    // $('.product-form-grid-radio').find('.product-pack-list').find('.pack_list-value').removeClass('active_pack');
                    // $('.product-form-grid-radio').find('.product-pack-list.mobile_only').find('.pack_list-value:first-child').addClass('active_pack').find('input').trigger('click');
                }
            }

            if (!$('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').hasClass('disable_subscription')) {
                //         $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').find('input').trigger('click');
                //         $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').trigger('click');
            }



            $('.template-product .shiipevery-select.timing_selector').find('.days-select').attr('name', 'shipping_interval_frequency');
            //       $('.shiipevery.timing_selector').find('.daysinptt').attr('name','');
            if ($('.template-collection').length > 0) {
                frqncy = '.shiipevery.timing_selector';
            } else {
                frqncy = '.shiipevery-select.timing_selector';
            }
        }

        //     if($('.tab-slider--trigger[rel="tab2"]').hasClass('active')){
        //       $(frqncy).slideDown('slow');
        //     } else{
        //       $(frqncy).slideUp('slow'); 
        //     }
    });

    //   if($(window).width() < 959){
    //     if($('.featured-icons.has_more li').length > 4){
    //       $('.featured-icons.has_more').slick({
    //         infinite: false,
    //         slidesToShow: 4,
    //         slidesToScroll: 1
    //       });
    //     }
    //   }

    //   function slick_icon(){
    //     console.log('ddd');
    //     if($('.featured-icons.has_more li').length > 4){
    //       $('.featured-icons.has_more').slick({
    //         infinite: false,
    //         slidesToShow: 8,
    //         slidesToScroll: 8,
    //         variableWidth: true,
    //         responsive: [
    //           {
    //             breakpoint: 959,
    //             settings: {
    //               slidesToShow: 4,
    //               slidesToScroll: 1,
    //               infinite: true,
    //               variableWidth: false,
    //               dots: false
    //             }
    //           }
    //         ]
    //       });
    //     }
    //   }

    //   slick_icon();
    // console.log('test')
    $(".template-product .tab-slider--nav li").click(function() {
        $(".tab-slider--body").hide();
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).fadeIn();
        if ($(this).attr("rel") == "tab2") {
            $('.tab-slider--tabs').addClass('slide');
            $(frqncy).slideDown('slow');
            if ($(window).width() < 960) {
                // $('.bundles-product-main .option-values').slideUp('slow');
            }
            $('[data-product-submit]').addClass('has_subscription').find('.sub-save').show();
            $('[data-product-submit]').find('.one-time').hide();
            if ($(window).width() < 960) {
                $(this).parents('.product-form-grid-radio').find('.bundles-product').find('.option-value-input[data-qty="1"]').trigger('click');
            }
            if (($('.product-pack-list').length > 0)) {
                $('.product-pack-list').addClass('hide_slide');
                //         $('.item-quantity-wrap').show().find('input').attr('name','quantity');
            }
        } else {
            $('.tab-slider--tabs').removeClass('slide');
            $(frqncy).slideUp('slow');
            if ($(window).width() < 960) {
                $('.bundles-product-main .option-values').slideDown('slow');
                if (($('.product-pack-list.mobile_only').length > 0)) {
                    // $('.product-pack-list.mobile_only').slideDown('slow');
                    $('.item-quantity-wrap').hide().find('input').removeAttr('name');
                }
            } else {
                if (($('.product-pack-list.desk_only').length > 0)) {
                    $('.product-pack-list.desk_only').removeClass('hide_slide');
                    $('.item-quantity-wrap').hide().find('input').removeAttr('name');
                }
            }
            $('[data-product-submit]').removeClass('has_subscription').find('.sub-save').hide();
            $('[data-product-submit]').find('.one-time').show();

        }

        $(".tab-slider--nav li").removeClass("active");
        $(this).addClass("active");

    });

    $(".collapsible-panel-block-content-meta .collapsible-heading").click(function() {
        $(".collapsible-heading").removeClass("active");
        $(".collapsible-content").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active");
        }
    });

    $(".collapsible-panel-block-heading:not(.notThis)").click(function() {
        $(".collapsible-panel-block-heading:not(.notThis)").removeClass("active").attr("aria-expanded", "false");
        $(".collapsible-panel-block-content:not(.notThis)").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active").attr("aria-expanded", "true");
        }
    });



    $(".collapsible-panel-block-heading.notThis").click(function() {
        $(".collapsible-panel-block-heading.notThis").removeClass("active").attr("aria-expanded", "false");
        $(".collapsible-panel-block-content.notThis").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active").attr("aria-expanded", "true");
        }
    });



    $(".collapsible-panel-faq").click(function() {
        $(this).toggleClass("active");
        $(this).next().slideToggle();
    });

    $(".collection-grid-custom .tab-slider--nav li label").click(function() {
        //     $(".tab-slider--body").hide();
        var activeTab = $(this).parents('.subsave').attr("rel");

        //     $("#" + activeTab).fadeIn();
        if ($(this).parents('.subsave').attr("rel") == "tab2") {
            $(this).parents('.tab-slider--tabs').addClass('slide');
            $(this).parents('.product-card-interactions').find(frqncy).slideUp('slow');
            $(this).parents('.product-card-interactions').find('[data-product-submit]').addClass('has_subscription').find('.sub-save').show();
            $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.one-time').hide();
            if ($(this).closest('.product-card-interactions').find('.product-pack-list').length > 0) {
                $(this).closest('.product-card-interactions').find('.product-pack-list').slideUp('slow');
            }

        } else {
            $(this).parents('.tab-slider--tabs').removeClass('slide');
            $(this).parents('.product-card-interactions').find(frqncy).slideUp('slow');
            $(this).parents('.product-card-interactions').find('[data-product-submit]').removeClass('has_subscription').find('.sub-save').hide();
            $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.one-time').show();
            if ($(this).closest('.product-card-interactions').find('.product-pack-list').length > 0) {
                $(this).closest('.product-card-interactions').find('.product-pack-list').slideDown('slow');
                var mprice = $(this).closest('.product-card-interactions').find('.pack_list-value.active_pack .packprice').attr('data-mprice');
                var cprice = $(this).closest('.product-card-interactions').find('.pack_list-value.active_pack .packprice').attr('data-cprice');
                if (cprice != '') {
                    $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.one-time').html('<del>' + cprice + '</del><span>' + mprice + '</span>');
                } else {
                    $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.one-time').html('<span>' + mprice + '</span>');
                }
            }
        }
        $(this).closest(".tab-slider--nav").find("li").removeClass("active");
        $(this).parents('.tab-slider--trigger').addClass("active");
    });

    var vid = $('.template-product .option-value-input:checked').attr('data-varid');
    $('#rc_duplicate_selector')
        .val(vid)
        .trigger('change');

    var v_id = $('.template-product .option-value-input:checked')
    if ($(v_id).hasClass('not_one_qty') || $(v_id).parents('.product-form-grid-radio').find('.strenghwrap').hasClass('hide_subscribe_for_this')) {
        // $(v_id).parents('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab1"]').trigger('click');
        // $(v_id).parents('.product-form-grid-radio').find('.strenghwrap').slideUp('slow').addClass('remove_subsription');
        $(v_id).parents('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').addClass('unavailable_subscribe').find('.unavailable_text').text('Unavailable for this product');
    } else {
        $(v_id).parents('.product-form-grid-radio').find('.strenghwrap:not(.hide_subscribe_for_this)').removeClass('unavailable_subscribe');
    }

    $('.template-product .option-value-input').on('change', function() {
        var vari = $(this).attr('data-varid');
        var activePack = $('.pack_list-value.active_pack input').val();
        $('#rc_duplicate_selector')
            .val(vari)
            .trigger('change');
        // console.log('Innnn');
        if ($(this).hasClass('hideVariantSubscription')) {
            $(this).parents('.product-form-grid-radio').find('li.tab-slider--trigger.subsave').addClass('disable_subscription');
            $(this).parents('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab1"]').find('input').trigger('click');
            $(this).parents('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').find('.subscription_unavailable').text('Subscribe & Save Unavailable');
            // if($(window).width() > 960){
            //  $('.product-form-grid-radio').find('.product-pack-list.desk_only').find('.pack_list-value:first-child').addClass('active_pack').find('input').trigger('click');
            // }else{
            //   $('.product-form-grid-radio').find('.product-pack-list.mobile_only').find('.pack_list-value:first-child').addClass('active_pack').find('input').trigger('click');
            // }
        } else {
            $(this).parents('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').find('.subscription_unavailable').text('Subscribe & Save');
            $(this).parents('.subscription_inner').find('li.tab-slider--trigger.subsave').removeClass('disable_subscription');
        }

        if ($(this).hasClass('not_one_qty') || $(this).parents('.product-form-grid-radio').find('.strenghwrap').hasClass('hide_subscribe_for_this')) {
            $(this).parents('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab1"]').find('input').trigger('click');
            $(this).parents('.product-form-grid-radio').find('.strenghwrap').addClass('remove_subsription');
            $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').addClass('unavailable_subscribe');
            if ($(window).width() > 767) {
                // // $(this).parents('.product-form-grid-radio').find('.strenghwrap').find('.tab-slider--trigger').slideUp('slow');
            }
        } else {
            $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').removeClass('unavailable_subscribe');
            $(this).parents('.product-form-grid-radio').find('.strenghwrap:not(.hide_subscribe_for_this)').removeClass('remove_subsription');
            if ($(window).width() > 767) {
                // $(this).parents('.product-form-grid-radio').find('.strenghwrap:not(.hide_subscribe_for_this)').find('.tab-slider--trigger').slideDown('slow');
            }
        }

        var pack_mprice = parseInt($(this).attr('data-pack-price'));
        var pack_cprice = parseInt($(this).attr('data-pack-com-price'));
        if ($('.product-pack-list').length > 0) {

            $('.pack_list-value').each(function() {
                var pack = parseInt($(this).find('.title-label').attr('data-pack'));
                var percentage = $(this).find('.option-value-name').attr('data-pv');
                var mprice = pack_mprice * pack;
                var cprice = pack_cprice * pack;

                if ((percentage != undefined) && (percentage != '')) {
                    //           console.log('hihihi'+percentage);
                    var discounted = mprice * parseInt(percentage) / 100;
                    var final = mprice - discounted;
                    $(this).find('.packprice').attr('data-cprice', Shopify.formatMoney(final)).text(Shopify.formatMoney(final));
                } else {
                    $(this).find('.packprice').attr('data-cprice', Shopify.formatMoney(mprice)).text(Shopify.formatMoney(mprice));
                }
                if ((percentage != undefined) && (percentage != '')) {
                    $(this).find('.com-price').remove();
                    $(this).find('.packprice').attr('data-mprice', Shopify.formatMoney(mprice)).after(' <span class="com-price"><del>' + Shopify.formatMoney(mprice) + '</del></span>');
                } else if (cprice > mprice) {
                    $(this).find('.com-price').remove();
                    $(this).find('.packprice').attr('data-mprice', Shopify.formatMoney(mprice)).after(' <span class="com-price"><del>' + Shopify.formatMoney(cprice) + '</del></span>');
                } else {
                    $(this).find('.com-price').remove();
                }
            });
        }

        var input_var = '';
        if ($('select[name="id"]').val()) {
            input_var = $('select[name="id"] option[data-option1="' + $(this).val() + '"]').val();
        } else if ($('input[name="id"]').val()) {
            input_var = $('input[name="id"]').val();
        }
        if (input_var != '') {
            if (typeof p_img_variant !== 'undefined') {
                var obj_img = p_img_variant.filter(function(variant) {
                    return variant.var_id == input_var
                });
                if (parseInt(obj_img.length) > 0) {
                    $('.thumb_inner[data-media="' + obj_img[0].img_id + '"]').trigger('click');
                }
            }
        }

        var price = $(this).data('price');
        var compare_price = $(this).data('compare-price');
        var save_price = $(this).data('save-price');
        var com_price = $(this).data('com-price');
        var dis_price = $(this).data('discount');
        var btn_cart = $(this).data('cart');
        var data_id = $(this).data('id');
        var qty = $(this).data('qty');

        if ($('.pack_list-value.active_pack').find('input[value="3"]').length > 0) {
            var old_price = $(this).parents('.product-form-grid-radio').find('.pack_list-value.active_pack').find('.packprice').attr('data-cprice');
            var new_price = $(this).parents('.product-form-grid-radio').find('.pack_list-value.active_pack').find('.packprice').attr('data-mprice');
            $(this).parents('.product-form-grid-radio').find('[data-product-submit]').find('.one-time').html('<span>' + old_price + '</span><del>' + new_price + '</del>'); //THE ONE
            $('li.tab-slider--trigger.otp').find('.main_price').html('<span>' + old_price + '</span><del>' + new_price + '</del>');
        } else {
            if (compare_price) {
                $('li.tab-slider--trigger.otp').find('.main_price').html('<span>' + price + '</span><del>' + compare_price + '</del>');
                $(this).parents('.product-form-grid-radio').find('[data-product-submit]').find('.one-time').html('<span>' + price + '</span><del>' + compare_price + '</del>'); //THE ONE
            } else {
                $('li.tab-slider--trigger.otp').find('.main_price').html('<span>' + price + '</span>');
                $(this).parents('.product-form-grid-radio').find('[data-product-submit]').find('.one-time').html('<span>' + price + '</span>'); //THE ONE
            }
        }
        console.log('are we here?')
        // $('li.tab-slider--trigger.subsave').find('.price_sub .price').html('<span>'+com_price+'</span><del>'+price+'</del>');
        $(this).parents('.product-form-grid-radio').find('[data-product-submit]').find('.sub-save').html('<span>' + com_price + '</span><del>' + price + '</del>');
        $('.product-pack-list.desk_only .pack_list-value input[value="' + activePack + '"]').parent('.pack_list-value').trigger('click').addClass('active_pack');
    });



    $("body").on('click', '.thumb_inner', function(e) {
        if (e.originalEvent !== undefined) {
            var cur_img_id = $(this).attr('data-media');
            if (typeof p_img_variant !== 'undefined') {
                var obj_img = p_img_variant.filter(function(variant) {
                    return variant.img_id == cur_img_id
                });
                if (parseInt(obj_img.length) > 0) {
                    var input_var1 = '';
                    if ($('select[name="id"]').length > 0) {
                        input_var1 = $('select[name="id"] option[data-variant-id="' + obj_img[0].var_id + '"]')
                    } else if ($('input[name="id"]').length > 0) {
                        input_var1 = $('input[name="id"] option[data-variant-id="' + obj_img[0].var_id + '"]')
                    }
                    var data_option1 = input_var1.attr('data-option1');
                    var data_option2 = input_var1.attr('data-option2');
                    var data_option3 = input_var1.attr('data-option3');
                    if (data_option1 != '') {
                        $('.option-values[data-op_index="1"] input.option-value-input[value="' + data_option1 + '"]').prop('checked', 'true');
                    }
                    if (data_option2 != '') {
                        $('.option-values[data-op_index="2"] input.option-value-input[value="' + data_option1 + '"]').prop('checked', 'true');
                    }
                    if (data_option3 != '') {
                        $('.option-values[data-op_index="3"] input.option-value-input[value="' + data_option1 + '"]').prop('checked', 'true');
                    }
                }
            }
        }
    });

    $("body").on('click', '.slick-arrow,.slick-dots', function(e) {
        if (e.originalEvent !== undefined) {
            var cur_img_id = $(this).closest('.product-gallery').find('.product-gallery--navigation').find('.slick-current').find('.thumb_inner').attr('data-media');
            if (typeof p_img_variant !== 'undefined') {
                var obj_img = p_img_variant.filter(function(variant) {
                    return variant.img_id == cur_img_id
                });
                if (parseInt(obj_img.length) > 0) {
                    var input_var1 = '';
                    if ($('select[name="id"]').length > 0) {
                        input_var1 = $('select[name="id"] option[data-variant-id="' + obj_img[0].var_id + '"]')
                    } else if ($('input[name="id"]').length > 0) {
                        input_var1 = $('input[name="id"] option[data-variant-id="' + obj_img[0].var_id + '"]')
                    }
                    var data_option1 = input_var1.attr('data-option1');
                    var data_option2 = input_var1.attr('data-option2');
                    var data_option3 = input_var1.attr('data-option3');
                    if (data_option1 != '') {
                        $('.option-values[data-op_index="1"] input.option-value-input[value="' + data_option1 + '"]').prop('checked', 'true');
                    }
                    if (data_option2 != '') {
                        $('.option-values[data-op_index="2"] input.option-value-input[value="' + data_option1 + '"]').prop('checked', 'true');
                    }
                    if (data_option3 != '') {
                        $('.option-values[data-op_index="3"] input.option-value-input[value="' + data_option1 + '"]').prop('checked', 'true');
                    }
                }
            }
        }
    });


    /*$('.product-gallery--slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      var cur_img_id = $(this).find('.slick-slide[data-slick-index="'+currentSlide+'"]').find('.product-gallery--viewport--figure').attr('data-media');
      if(typeof p_img_variant !== 'undefined'){
        var obj_img = p_img_variant.filter(function (variant) { return variant.img_id == cur_img_id });
        console.log('cur_img_id',cur_img_id)
        if(parseInt(obj_img.length) > 0 ){
          var input_var1 = '';
          if($('select[name="id"]').length > 0 ){
            input_var1 = $('select[name="id"] option[data-variant-id="'+ obj_img[0].var_id +'"]')
          }else if($('input[name="id"]').length > 0 ){
            input_var1 = $('input[name="id"] option[data-variant-id="'+ obj_img[0].var_id +'"]')
          }
          var data_option1 = input_var1.attr('data-option1');
          var data_option2 = input_var1.attr('data-option2');
          var data_option3 = input_var1.attr('data-option3');
          console.log(event,slick,'====')
          if(data_option1 != ''){
            $('.option-values[data-op_index="1"] input.option-value-input[value="'+ data_option1 +'"]').attr('checked', true).trigger('click');
          }
          if(data_option2 != ''){
            $('.option-values[data-op_index="2"] input.option-value-input[value="'+ data_option1 +'"]').attr('checked', true).trigger('click');
          }
          if(data_option3 != ''){
            $('.option-values[data-op_index="3"] input.option-value-input[value="'+ data_option1 +'"]').attr('checked', true).trigger('click');
          }
        }
      }
    });*/

    $('.collection-grid-custom').each(function() {
        var col_var = $(this).find('.option-value-input:checked');
        //     console.log('col_var',col_var.length);
        var compare_price = $(col_var).data('compare-price');
        var price = $(col_var).data('price');
        var save_price = $(col_var).data('save-price');
        var com_price = $(col_var).data('com-price');
        var dis_price = $(col_var).data('discount');
        var btn_cart = $(col_var).data('cart');
        var data_id = $(col_var).data('id');
        var qty = $(col_var).data('qty');
        if (save_price) {
            $(col_var).parents('.collection-grid-custom').find('.badge-sale').show().text('SAVE ' + save_price);
        } else {
            $(col_var).parents('.collection-grid-custom').find('.badge-sale').hide();
        }
        $(col_var).parents('.product-card-interactions').find('.product-quantity-input').val(qty);
        if (compare_price) {
            $(col_var).parents('.product-card-interactions').find('.main_price').html('<span class="money">' + price + '</span><del>' + com_price + '</del>');
        } else {
            $(col_var).parents('.product-card-interactions').find('.main_price').html('<span class="money">' + price + '</span>');
        }
        $(col_var).parents('.product-card-interactions').find('.sub_discount_price').text(com_price);
        if (btn_cart == true) {
            if ($(col_var).parents('.product-card-interactions').find('.add_into_popup').length > 0) {
                $(col_var).parents('.product-card-interactions').find('[data-product-submit]').find('.product-card-interaction-addtocart-available').text('ADD TO CART');
                //         $(col_var).parents('.product-card-interactions').find('[data-product-submit]').find('.add_into_popup.product-card-interaction-addtocart-available').text('Continue to cart');
                $(col_var).parents('.product-card-interactions').find('[data-product-submit]').find('.add_into_popup.product-card-interaction-addtocart-available').text('Add to cart');
            } else {
                $(col_var).parents('.product-card-interactions').find('[data-product-submit]').find('.product-card-interaction-addtocart-available').text('ADD TO CART');
            }
            $(col_var).parents('.product-card-interactions').find('[data-product-submit]').attr('disabled', false);
        } else {
            $(col_var).parents('.product-card-interactions').find('[data-product-submit]').find('.product-card-interaction-addtocart-available').text('Sold Out');
            $(col_var).parents('.product-card-interactions').find('[data-product-submit]').attr('disabled', true);
        }

        // $(col_var).parents('.product-card-interactions').find('[data-product-submit]').find('.one-time').text(price);
        $(col_var).parents('.product-card-interactions').find('[data-product-submit]').find('.sub-save').html('<del>' + price + '</del><span>' + com_price + '</span>');
        $(col_var).parents('.product-card-interactions').find('[data-product-submit]').attr('data-product-variant-id', data_id);



        var vid = $(col_var).parents('.product-card-interactions').find('.option-value-input:checked').attr('data-varid');
        $(col_var).parents('.product-card-interactions').find('#rc_duplicate_selector')
            .val(vid)
            .trigger('change');

        var col_var = $(this).find('.option-value-input:checked');
        if ($(col_var).hasClass('not_one_qty') || $(col_var).parents('.product-card-interactions').find('.strenghwrap').hasClass('hide_subscribe_for_this')) {
            $(col_var).parents('.product-card-interactions').find('.tab-slider--tabs').find('li[rel="tab1"]').find('label').trigger('click');
            $(col_var).parents('.product-card-interactions').find('.strenghwrap').slideUp('slow').addClass('remove_subsription');
        } else {
            $(col_var).parents('.product-card-interactions').find('.strenghwrap:not(.hide_subscribe_for_this)').slideDown('slow').removeClass('remove_subsription');
        }
        //   if($(col_var).closest('.product-card-interactions').find('.product-pack-list').length > 0){
        if (!$(col_var).hasClass('hideVariantSubscription')) {
            // $(col_var).closest('.product-card-interactions').find('.tab-slider--trigger[rel="tab2"] label').trigger('click');
        }
        //   }
        if (($(col_var).closest('.product-card-interactions').find('.product-pack-list').length > 0) && ($(col_var).closest('.product-card-interactions').find('.tab-slider--trigger.active').attr('rel') == 'tab1')) {
            $(col_var).closest('.product-card-interactions').find('.product-pack-list').slideDown('slow');
        } else if ($(col_var).closest('.product-card-interactions').find('.product-pack-list').length > 0) {
            $(col_var).closest('.product-card-interactions').find('.product-pack-list').slideUp('slow');
        }


    });


    $('.collection-grid-custom .option-value-input').on('change', function() {
        var vari = $(this).attr('data-varid');
        $(this).parents('.product-card-interactions').find('#rc_duplicate_selector')
            .val(vari)
            .trigger('change');

        if ($(this).hasClass('hideVariantSubscription')) {
            $(this).parents('.product-inner').find('li.tab-slider--trigger.subsave').addClass('disable_subscription');
            $(this).parents('.product-inner').find('.tab-slider--tabs').find('li[rel="tab1"]').find('label').trigger('click');
        } else {
            $(this).parents('.product-inner').find('li.tab-slider--trigger.subsave').removeClass('disable_subscription');
        }

        var col_var = $(this);
        if ($(col_var).hasClass('not_one_qty') || $(col_var).parents('.product-card-interactions').find('.strenghwrap').hasClass('hide_subscribe_for_this')) {
            $(col_var).parents('.product-card-interactions').find('.tab-slider--tabs').find('li[rel="tab1"]').find('label').trigger('click');
            $(col_var).parents('.product-card-interactions').find('.strenghwrap').addClass('remove_subsription');
            //       if($(window).width() > 767){
            $(col_var).parents('.product-card-interactions').find('.strenghwrap').slideUp('slow');
            //       }
        } else {
            console.log('Not INN');
            $(col_var).parents('.product-card-interactions').find('.strenghwrap:not(.hide_subscribe_for_this)').removeClass('remove_subsription');
            //       if($(window).width() > 767){
            $(col_var).parents('.product-card-interactions').find('.strenghwrap:not(.hide_subscribe_for_this)').slideDown('slow');
            //       }
        }
        var price = $(this).data('price');
        var compare_price = $(this).data('compare-price');
        var save_price = $(this).data('save-price');
        var com_price = $(this).data('com-price');
        var dis_price = $(this).data('discount');
        var btn_cart = $(this).data('cart');
        var data_id = $(this).data('id');
        var qty = $(this).data('qty');
        if (save_price) {
            $(this).parents('.collection-grid-custom').find('.badge-sale').show().text('SAVE ' + save_price);
        } else {
            $(this).parents('.collection-grid-custom').find('.badge-sale').hide();
        }
        $(this).parents('.product-card-interactions').find('.product-quantity-input').val(qty);
        if (compare_price) {
            $(this).parents('.product-card-interactions').find('.main_price').html('<span class="money">' + price + '</span><del>' + compare_price + '</del>');
        } else {
            $(this).parents('.product-card-interactions').find('.main_price').html('<span class="money">' + price + '</span>');
        }
        $(this).parents('.product-card-interactions').find('.sub_discount_price').text(com_price);
        if (compare_price) {
            $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.one-time').html('<del>' + compare_price + '</del><span>' + price + '</span>'); //THE ONE
        } else {
            $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.one-time').html('<span>' + price + '</span>'); //THE ONE
        }

        $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.sub-save').html('<del>' + price + '</del><span>' + com_price + '</span>');
        $(this).parents('.product-card-interactions').find('[data-product-submit]').attr('data-product-variant-id', data_id);
        if (btn_cart == true) {
            if ($(this).parents('.product-card-interactions').find('.add_into_popup').length > 0) {
                $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.product-card-interaction-addtocart-available').text('ADD TO CART');
                //         $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.add_into_popup.product-card-interaction-addtocart-available').text('Continue to cart');
                $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.add_into_popup.product-card-interaction-addtocart-available').text('Add to cart');
            } else {
                $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.product-card-interaction-addtocart-available').text('ADD TO CART');
            }
            $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.product-card-interaction-addtocart-available').text('ADD TO CART');
            $(this).parents('.product-card-interactions').find('[data-product-submit]').attr('disabled', false);
        } else {
            $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.product-card-interaction-addtocart-available').text('Sold Out');
            $(this).parents('.product-card-interactions').find('[data-product-submit]').attr('disabled', true);
        }

        var pack_mprice = parseInt($(col_var).attr('data-pack-price'));
        var pack_cprice = parseInt($(col_var).attr('data-pack-com-price'));
        if ($(this).parents('.product-card-interactions').find('.product-pack-list').length > 0) {
            $(this).parents('.product-card-interactions').find('.pack_list-value').each(function() {
                var pack = parseInt($(this).find('.title-label').attr('data-pack'));
                var percentage = $(this).find('.option-value-name').attr('data-pv');
                var mprice = pack_mprice * pack;
                var cprice = pack_cprice * pack;

                if ((percentage != undefined) && (percentage != '')) {
                    var discounted = mprice * parseInt(percentage) / 100;
                    mprice = mprice - discounted;
                }
                $(this).find('.packprice').text(Shopify.formatMoney(mprice)).attr('data-mprice', Shopify.formatMoney(mprice)).attr('data-cprice', '');
                if ((percentage != undefined) && (percentage != '')) {
                    $(this).find('.com-price').remove();
                    $(this).find('.packprice').attr('data-mprice', Shopify.formatMoney(mprice)).attr('data-cprice', Shopify.formatMoney(pack_mprice * pack)).after(' <span class="com-price"><del>' + Shopify.formatMoney(pack_mprice * pack) + '</del></span>');
                    if (($(this).parents('.product-card-interactions').find('.tab-slider--trigger.active').attr('rel') == 'tab1') && ($(this).hasClass('active_pack'))) {
                        $(this).parents('.product-card-interactions').find('[data-product-submit]').find('.one-time').html('<del>' + Shopify.formatMoney(pack_mprice * pack) + '</del><span>' + Shopify.formatMoney(mprice) + '</span>');
                    }
                } else if (cprice > mprice) {
                    $(this).find('.com-price').remove();
                    $(this).find('.packprice').attr('data-mprice', Shopify.formatMoney(mprice)).attr('data-cprice', Shopify.formatMoney(cprice)).after(' <span class="com-price"><del>' + Shopify.formatMoney(cprice) + '</del></span>');
                } else {
                    $(this).find('.com-price').remove();
                }

            });
        }

    });

});
$(document).ready(function() {
    var hg = $('.main-header-wrap.main-header--minimal-sticky').height();
    $('.mobile-dropdown').css('top', hg);
    $(window).resize(function() {
        var hg = $('.main-header-wrap.main-header--minimal-sticky').height();
        $('.mobile-dropdown').css('top', hg);
        if ($(window).width() > 959) {
            $('html').removeClass('scroll-locked');
        } else {
            if ($('.mobile-dropdown').hasClass('active')) {
                $('html').addClass('scroll-locked');
            }
        }

        // if(($('.template--product .product-pack-list').length > 0)&&($(window).width() < 960)){
        //   // $('.template--product .product-pack-list').slideUp('slow');
        //   $('.template--product .product-pack-list').find('input[name="quantity"]').prop('checked',false);
        //   $('.template--product .item-quantity-wrap').hide().find('input').attr('name','quantity');
        // }else{
        //   $('.template--product .product-pack-list').find('.active_pack input[name="quantity"]').prop('checked',true);
        //   if($('.template--product .product-pack-list').length > 0){
        //     $('.template--product .item-quantity-wrap').hide();
        //   }
        // }

        // if($(window).width() > 959){
        //   if($('.template-product').find('.tab-slider--trigger.check-trigger').length > 0){
        //     if($('.template-product').find('.tab-slider--trigger.check-trigger.active').attr('rel')!="tab2"){
        //       if($('.template--product .product-pack-list').length > 0){
        //         // $('.template--product .product-pack-list').slideDown('slow');
        //       }
        //     }
        //   }
        // }


    });
    $("body").on('click', '.popup-btn', function(e) {
        e.preventDefault();
        var cur = $(this).attr('data-popup-pro');
        $('#' + cur).find('.addcartpopup-wrap').addClass("active");
        $('.addcartpopup-overlay').addClass("active");
        $('.addcartpopup-wrap.active').clone().appendTo('.add-tocart-popup').show();
        $('.featured-collection-carousel-membership .addcart-popup').find('.addcartpopup-wrap').hide();
        $('html').addClass("scroll-locked");
        $('body').addClass("active-popup");
    });

    $("body").on('click', '.product-submit-recharge', function(e) {
        e.preventDefault();
        if ($('[name="purchase_type"]:checked').val() == 'autodeliver') {
            $('[data-product-submit]').addClass('has_normal');
            $('[data-product-submit]').trigger('click');
        } else {
            var cur = $(this).attr('data-popup-pro');
            $('#' + cur).addClass("active");
            $('body').addClass("recharge_active-popup");
            $('.strenghwrap').removeClass('has_default');
            $('.cm-add-popup-overlay').addClass("active");
            $('.quantity_selector_normal').removeAttr('name');
            $('.quantity_selector_rc').attr('name', 'quantity');
            $('[data-product-submit]').addClass('has_subscription');
        }
    });

    $("body").on('click', '.addcart-popup-recharge .addproduct_normal', function(e) {
        e.preventDefault();
        $('.quantity_selector_normal').attr('name', 'quantity');
        $('.quantity_selector_rc').removeAttr('name');
        $('.addcartpopup-overlay').removeClass("active");
        $('.addcartpopup-wrap').removeClass("active");
        $('.addcart-popup-recharge').removeClass("active");
        $('html').removeClass("scroll-locked");
        $('body').removeClass("recharge_active-popup");
        $('.strenghwrap').addClass('has_default');
        $('.cm-add-popup-overlay').removeClass("active");
        $('.add-tocart-popup').empty();
        $('[data-product-submit]').removeClass('has_subscription');
        $('[data-product-submit]').trigger('click');
    });

    $("body").on('click', '.addcart-popup-recharge .addproduct_sub', function(e) {
        e.preventDefault();
        $('[data-product-submit]').trigger('click');
        $('.strenghwrap').addClass('has_default');
    });

    $("body").on('click', '.addcartpopup-overlay,.addcartpopup-wrap .close-popup,.cm-add-popup-overlay,.addcart-popup-recharge-inner .close-popup', function(e) {
        e.preventDefault();
        $('.quantity_selector_normal').attr('name', 'quantity');
        $('.quantity_selector_rc').removeAttr('name');
        $('.addcartpopup-overlay').removeClass("active");
        $('.addcartpopup-wrap').removeClass("active");
        $('.addcart-popup-recharge').removeClass("active");
        $('html').removeClass("scroll-locked");
        $('body').removeClass("recharge_active-popup");
        $('body').removeClass("active-popup");
        $('.strenghwrap').addClass('has_default');
        $('.cm-add-popup-overlay').removeClass("active");
        $('.add-tocart-popup').empty();
    });
    $('.faq-question').click(function(e) {
        e.preventDefault();
        $('.faq-answre').slideUp('100');
        $('.faq-question').parent().removeClass('active').find('.faq-question').attr('aria-expanded', 'false');
        if (!$(this).parent().find('.faq-answre').is(":visible")) {
            $(this).parent().find('.faq-answre').slideToggle('500');
            $(this).parent().toggleClass('active').find('.faq-question').attr('aria-expanded', 'true');
        }
    });


    if ($('.graph-section').length > 0) {
        $(".graph-section").addClass("draw");
    }

    $("body").on('click', '.add_to_col_cart', function(e) {
        e.preventDefault();
        var cc = $(this).attr('data-cart');
        $(this).find('.cart_text').hide();
        $(this).find('.product-card-interaction-addtocart-spinner').show();
        setInterval(function() {
            $(this).find('.cart_text').show();
            $(this).find('.product-card-interaction-addtocart-spinner').hide();
        }, 2000);
        setTimeout(function() {
            $('.addcart-container .cart_text').show();
            $('.addcart-container .product-card-interaction-addtocart-spinner').hide();
            $('.addcartpopup-overlay').removeClass("active");
            $('.addcartpopup-wrap').removeClass("active");
            $('html').removeClass("scroll-locked");
            $('body').removeClass("active-popup");
            $('.' + cc).trigger('click');
            $('.add-tocart-popup').empty();
        }, 1000);
    });

    $("body").on("click", ".shop-by-solutions-header li a.not-redirect", (function(e) {
        e.preventDefault();
        var toph = $(this).attr("href");
        $(".shop-by-solutions-header li a").removeClass("active"), $(this).addClass("active");
        if ($(window).width() > 767) {
            var head_h = $(".shop-by-solution-header").outerHeight();
            var st = $(toph).offset().top - head_h - 70;
        } else {
            var st = $(toph).offset().top - 170;
        }
        $("html, body").animate({
            scrollTop: st
        }, "slow")
    }));

    //   $("body").on("click", ".mobile-shop-by-solution-nav-swiper li a", (function (e) {
    //     e.preventDefault();
    //     var toph = $(this).attr("href");
    //     $(".mobile-shop-by-solution-nav-swiper li a").removeClass("active"), $(this).addClass("active");
    //     if($(window).width() > 767 ){
    //       var head_h = $(".shop-by-solution-header").outerHeight();
    //       var st = $(toph).offset().top - head_h - 70;
    //     }else{
    //       var st = $(toph).offset().top - 50;
    //     }
    //     $("html, body").animate({
    //       scrollTop: st
    //     }, "slow")
    //   }));
    $("#learn-more").click(function() {
        $('html, body').animate({
            scrollTop: $("#shopify-section-membership-how-work").offset().top - 20
        }, 1500);
    });

    var cookieExpireSet = $('.wel_back_pop').data('cookie-interval');
    var NewsletterCookie = "premium-customer-cookie";

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    var x = getCookie(NewsletterCookie);
    //   console.log('x',x)
    if (x) {
        $('.wel_back_pop').removeClass('active_popup');
    } else {
        $('.wel_back_pop').addClass('active_popup');
    }
    $('.wel_close_icon , .pop_overlay').click(function() {
        $('.wel_back_pop').removeClass('active_popup');
        setCookie(NewsletterCookie, '1', cookieExpireSet);
    });
    $('body').on('click', '.premium-shop-now', function() {
        $('.wel_back_pop').removeClass('active_popup');
        setCookie(NewsletterCookie, '1', cookieExpireSet);
        var url = $(this).attr('data-href');
        window.location = url;
    });

});



$(window).scroll(function(e) {
    e.preventDefault();
    var height_top = $('header').height();
    if ($(this).scrollTop() > height_top) {
        $('.shop-by-solution-header').addClass('fixed').css('top', height_top + 'px');
        $('.cm-main-wrapper').addClass('fixed');

    } else {
        $('.shop-by-solution-header').removeClass('fixed').css('top', '0px');
        $('.cm-main-wrapper').removeClass('fixed');
    }

    if ($("button.product-submit").length > 0 && $(".qty-atc-wrapper").length > 0) {
        var fixmeTop = $("header").outerHeight();
        var window_height = $(window).scrollTop() + 30;
        $("button.product-submit").closest('.qty-atc-wrapper').removeClass("sticky-btn");
        fixmeTop = +$("button.product-submit").closest('.qty-atc-wrapper').offset().top;
        if (window_height >= fixmeTop) {
            $("button.product-submit").closest('.qty-atc-wrapper').addClass("sticky-btn");
        } else {
            $("button.product-submit").closest('.qty-atc-wrapper').removeClass("sticky-btn");
        }
    }

    if ($("button.add_to_cart_btn").length > 0 && $(".add_cart_wpr").length > 0) {
        var fixmeTop = $("header").outerHeight();
        var window_height = $(window).scrollTop() + 30;
        $("button.add_to_cart_btn").closest('.add_cart_wpr').removeClass("sticky-btn");
        fixmeTop = +$("button.add_to_cart_btn").closest('.add_cart_wpr').offset().top;
        if (window_height >= fixmeTop) {
            $("button.add_to_cart_btn").closest('.add_cart_wpr').addClass("sticky-btn");
        } else {
            $("button.add_to_cart_btn").closest('.add_cart_wpr').removeClass("sticky-btn");
        }
    }

    // var fixmeTop = $('.qty-atc-wrapper').position().top ;
    // var window_height = $(window).scrollTop();
    // $("button.product-submit").closest('.qty-atc-wrapper').removeClass("sticky-btn");
    // if ( window_height >= fixmeTop) {
    //   $("button.product-submit").closest('.qty-atc-wrapper').addClass("sticky-btn");
    // } else {
    //   $("button.product-submit").closest('.qty-atc-wrapper').removeClass("sticky-btn");
    // }
});



$(document).ready(function() {
    if (window.location.href.indexOf("/shop-by-solution#") > -1) {
        var url = window.location.href;
        var test = url.split("#");
        var toph = test[1];
        $(".shop_by_solutions_header li a").removeClass("active"), $(this).addClass("active");
        if ($(window).width() > 767) {
            var head_h = $(".shop-by-solution-header").outerHeight();
            var st = $('#' + toph).offset().top - head_h - 70;
        } else {
            var st = $('#' + toph).offset().top - 180;
        }
        $("html, body").animate({
            scrollTop: st
        }, "slow")
    }
});

function ChangeUrl(page, url) {
    if (typeof(history.pushState) != "undefined") {
        var obj = {
            Page: page,
            Url: url
        };
        history.pushState(obj, obj.Page, obj.Url);
    } else {
        alert("Browser does not support HTML5.");
    }
}
$('li.redirect').click(function(event) {
    var href_link = $(this).attr('data-href');
    if (href_link.indexOf("/shop-by-solution#") > -1) {
        ChangeUrl('url', href_link);
        window.location.reload();
    }
});

//Cm List responsive slider Js
if ($('.mobile-shop-by-solution-nav-swiper ul').length > 0) {
    $(function() {
        $('.mobile-shop-by-solution-nav-swiper ul').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            mobileFirst: true,
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '0px',
            infinite: false,
            focusOnSelect: true,
            initialSlide: 1
        });
    });
}

$(window).on('load resize scroll', function() {
    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight() / 2;
        var viewportTop = $(window).scrollTop();
        var viewportHalf = viewportTop + $(window).height() / 2;
        return elementBottom > viewportTop && elementTop < viewportHalf;
    };
    $('.shop-by-category').each(function() {
        if ($(this).isInViewport()) {
            var cur_section = $(this).attr('id');
            var go_index = $('.mobile-shop-by-solution-nav-swiper').find('li[data-current="' + cur_section + '"]').closest('.slick-slide').attr('data-slick-index');
            $('.mobile-shop-by-solution-nav-swiper ul').slick('slickGoTo', go_index);
            $('.mobile-shop-by-solution-nav-swiper').find('li').find('a').removeClass('active');
            $('.mobile-shop-by-solution-nav-swiper').find('li[data-current="' + cur_section + '"]').find('a').addClass('active');
        }
    });
});
$('.mobile-shop-by-solution-nav-swiper ul li a').click(function(e) {
    var anchor = $(this).attr('href');
    $(anchor).addClass('active').siblings().removeClass('active');
});

// $(window).on('load resize orientationchange', function () {
//   $('.shop_by_slick').each(function () {
//     var $shop_by_slick = $(this);
//     /* Initializes a slick carousel only on mobile screens */
//     // slick on mobile
//     if ($(window).width() > 767) {
//       if ($shop_by_slick.hasClass('slick-initialized')) {
//         $shop_by_slick.slick('unslick');
//       }
//     }
//     else {
//       if (!$shop_by_slick.hasClass('slick-initialized')) {
//         $shop_by_slick.slick({
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           mobileFirst: true,
//           arrows: true,
//           dots: false,
//           centerMode: true,
//           centerPadding: '0px',
//           infinite: true,
//           focusOnSelect: true
//         });
//       }
//     }
//   });
// });
var starttime = $('#countdown').attr("data-start-time");
var endtime = $('#countdown').attr("data-end-time");

function progress($element) {
    var start = new Date(starttime).getTime();
    var end = new Date(endtime).getTime();
    var current = new Date().getTime();
    end = Number(end) - Number(start), current = Number(current) - Number(start), start = 0;
    var width = (current * 100) / end;
    $element.find('div').css('width', width + '%');
}
(function() {
    var now = new Date().getTime();

    var countDownDate = new Date(endtime).getTime();
    var time_cur = parseInt(countDownDate) - parseInt(now);
    if (time_cur > 0) {
        $('.counttimer').show();
        let countdown = document.getElementById("countdown")
        let n_now = new Date().getTime(),
            leftitme = countDownDate - n_now;
        var new_left_tile = Math.floor((leftitme / 1000));
        var x = setInterval(function() {
            let now = new Date().getTime(),
                distance = countDownDate - now;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            if (days < 10) {
                days = '0' + days;
            }
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            if (hours < 10) {
                hours = '0' + hours;
            }
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            progress($('#progressBar'));
            // Output the result in an element with id="demo"
            $('#days').text(days);
            $('#hours').text(hours);
            $('#minutes').text(minutes);
            $('#seconds').text(seconds);
            // If the count down is over, write some text 
            if (distance < 0) {
                let countdown = document.getElementById("countdown")
                countdown.style.display = "none";
                clearInterval(x);
            }
        }, 1000);
    } else {
        $('.counttimer').hide();
    }
}());


(function() {
    var now = new Date().getTime();
    var endtime = $('#countdown').attr("data-end-time");
    var countDownDate = new Date(endtime).getTime();
    var time_cur = parseInt(countDownDate) - parseInt(now);
    if (time_cur > 0) {
        $('.counttimer').show();
        $('body').addClass('timer_count');
        let countdown = document.getElementById("countdownmob")
        let n_now = new Date().getTime(),
            leftitme = countDownDate - n_now;
        var new_left_tile = Math.floor((leftitme / 1000));
        var x = setInterval(function() {
            let now = new Date().getTime(),
                distance = countDownDate - now;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            if (days < 10) {
                days = '0' + days;
            }
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            if (hours < 10) {
                hours = '0' + hours;
            }
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            progress($('#progressBarmob'));
            // Output the result in an element with id="demo"
            $('#daysmob').text(days);
            $('#hoursmob').text(hours);
            $('#minutesmob').text(minutes);
            $('#secondsmob').text(seconds);
            // If the count down is over, write some text 
            if (distance < 0) {
                let countdown = document.getElementById("countdownmob")
                countdown.style.display = "none";
                clearInterval(x);
            }
        }, 1000);

    } else {
        $('.counttimer').hide();
        $('body').removeClass('timer_count');
    }
}());

$(window).scroll(function() {
    if ($(window).width() < 768) {
        var height_top = $('.main-header').height();
    } else {
        var height_top = $('header').height();
    }
    if ($(window).width() < 768) {
        if ($(this).scrollTop() > height_top) {
            $('header').addClass("sticky-header");
            if ($(this).scrollTop() > 50) {
                $('#shopify-section-pxs-announcement-bar').css('padding-top', height_top + 'px');
            }
        } else {
            $('header').removeClass("sticky-header");
            $('#shopify-section-pxs-announcement-bar').css('padding-top', '0px');
        }
    } else {
        if ($(this).scrollTop() > 1) {
            $('header').addClass("sticky-header");
            if ($(this).scrollTop() > 50) {
                $('#shopify-section-pxs-announcement-bar').css('padding-top', height_top + 'px');
            }
        } else {
            $('header').removeClass("sticky-header");
            $('#shopify-section-pxs-announcement-bar').css('padding-top', '0px');
        }
    }
});
$(document).ready(function() {
    if ($('.template-product').find('.tab-slider--trigger.check-trigger').length > 0) {
        if ($('.template-product').find('.tab-slider--trigger.check-trigger.active').attr('rel') != "tab2") {
            if ($('.template--product .product-pack-list').length > 0) {
                $('.product-form-grid-radio').find('.product-pack-list.desk_only').find('.pack_list-value.active_pack').find('input').trigger('click');
                // if($(window).width() < 960){
                //   // $('.template--product .product-pack-list.mobile_only').slideDown('slow');
                //   // $('.template--product .product-pack-list.desk_only').hide();
                //   $('.product-form-grid-radio').find('.product-pack-list').find('.pack_list-value').removeClass('active_pack');

                //   $('.product-form-grid-radio').find('.product-pack-list.desk_only').find('.pack_list-value:first-child').addClass('active_pack').find('input').trigger('click');
                // }else{
                // $('.template--product .product-pack-list.desk_only').slideDown('slow');
                //   // $('.template--product .product-pack-list.mobile_only').hide();
                //   $('.product-form-grid-radio').find('.product-pack-list').find('.pack_list-value').removeClass('active_pack');
                //   $('.product-form-grid-radio').find('.product-pack-list.desk_only').find('.pack_list-value:first-child').addClass('active_pack').find('input').trigger('click');
                // }
            }
        }
    }


    $('.has-item > a').click(function() {
        $('.has-item > a').removeClass('activelink');
        $(this).addClass('activelink');
        var tagid = $(this).data('tag');
        $('.tabbmenu').removeClass('active').addClass('hide');
        $('#' + tagid).addClass('active').removeClass('hide');
    });
});
$(window).on('load', function() {

    if ($('.subscription_inner.bundles-product-main .option-values').length > 0) {
        var com_val = $('.subscription_inner.bundles-product-main .option-values').find('input[type="radio"]:checked').attr('data-compare-price');
        $('.price.main_price').find('del').text(com_val);
    }
    if ($('.subscription_inner.has_single_subscription_inner .pack_list-value.active_pack').length > 0) {
        var sub_com_val = $('.subscription_inner.has_single_subscription_inner .pack_list-value.active_pack').find('del').text();
        $('.price.main_price').find('del').text(sub_com_val);
    }

    $('.collection-grid-custom').each(function() {
        if ($(this).hasClass('hideVariant-found')) {
            $(this).find('.option-value:first-child').find('.option-value-input').trigger('click');
        }
    });

    if ($(window).width() < 960) {
        if ($('.template-product').find('.product-form-grid-radio').find('.tab-slider--trigger.disable_subscription').length < 1) {
            // $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').trigger('click');
            // $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').find('input').trigger('click');
        }
    }
    if ($(window).width() > 959) {
        // if($('.template-product').find('.tab-slider--trigger.check-trigger').length > 0){
        //   if(!$('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').hasClass('disable_subscription')){
        //     $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab1"]').trigger('click');
        //     $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab1"]').find('input').trigger('click');
        //   }else{
        //     $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab1"]').trigger('click');
        //     $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab1"]').find('input').trigger('click');
        //   }
        // }
    }

    if ($('.template-product').find('.tab-slider--trigger.check-trigger').length > 0) {
        if ($('.template-product').find('.tab-slider--trigger.check-trigger.active').attr('rel') != "tab2") {
            if ($('.template--product .product-pack-list').length > 0) {
                $('.product-form-grid-radio').find('.product-pack-list.desk_only').find('.pack_list-value.active_pack').find('input').trigger('click');
                //   if($(window).width() < 960){
                //     $('.template--product .product-pack-list.mobile_only').slideDown('slow');
                //     $('.template--product .product-pack-list.desk_only').hide();
                //     $('.product-form-grid-radio').find('.product-pack-list').find('.pack_list-value').removeClass('active_pack');
                //     $('.product-form-grid-radio').find('.product-pack-list.mobile_only').find('.pack_list-value:first-child').addClass('active_pack').find('input').trigger('click');
                //   }else{
                //   $('.template--product .product-pack-list.desk_only').slideDown('slow');
                //     $('.template--product .product-pack-list.mobile_only').hide();
                //     $('.product-form-grid-radio').find('.product-pack-list').find('.pack_list-value').removeClass('active_pack');
                // $('.product-form-grid-radio').find('.product-pack-list.desk_only').find('.pack_list-value:first-child').addClass('active_pack').find('input').trigger('click');
                //   }
            }
        }
    }

    if ($('body.template--page-contact').length > 0) {
        var href = window.location.href;

        function updateAriaLabels() {
            $('.content-area .contact-tabs .tab-heading input').each(function() {
                if ($(this).parents('.tab-heading').hasClass('active')) {
                    $(this).attr('aria-label', 'selected');
                } else {
                    $(this).attr('aria-label', 'not selected');
                }
            });
        }

        if (href.indexOf('#') > -1) {
            var id = href.split('#');
            $('.content-area .contact-tabs .tab-heading').removeClass('active');
            $('.text-content-wrap .full-width-form').removeClass('active');
            $('.content-area .contact-tabs').find('input[data-href="#' + id[1] + '"]').parents('.tab-heading').addClass('active');
            $('.text-content-wrap #' + id[1]).addClass('active');
        } else {
            $('.content-area .contact-tabs .tab-heading:first').addClass('active');
            var id = $('.content-area .contact-tabs .tab-heading:first').find('input').attr('data-href');
            $('.text-content-wrap ' + id).addClass('active');
        }

        updateAriaLabels();

        $('.content-area .contact-tabs .tab-heading').on('click', function() {
            $('.content-area .contact-tabs .tab-heading').removeClass('active');
            $('.text-content-wrap .full-width-form').removeClass('active');

            $(this).addClass('active');
            var id = $(this).find('input').attr('data-href');
            $('.text-content-wrap ' + id).addClass('active');

            updateAriaLabels();
        });
    }
});
$(document).ready(function() {
    if ($('.subscription_inner.bundles-product-main .option-values').length > 0) {
        var com_val = $('.subscription_inner.bundles-product-main .option-values').find('input[type="radio"]:checked').attr('data-compare-price');
        $('.price.main_price').find('del').text(com_val);
    }
    if ($('.subscription_inner.has_single_subscription_inner .pack_list-value.active_pack').length > 0) {
        var sub_com_val = $('.subscription_inner.has_single_subscription_inner .pack_list-value.active_pack').find('del').text();
        $('.price.main_price').find('del').text(sub_com_val);
    }

    if ($('.template-product .option-values .option-value').length == 1) {
        $('.template-product .option-values .option-value').addClass('has_single_option');
        $('.template-product .option-values').addClass('has_single_option_main');
        $('.template-product .option-header').addClass('has_single_option_header');
        $('.template-product .subscription_inner').addClass('has_single_subscription_inner');
        // $('.subscription_inner.otpion-pro.whats-included.has_single_subscription_inner').hide();
    }

    $('body').on('click', '.section-membership-new-hero .action-button', function(e) {
        var url = $(this).attr('href');
        if (url.indexOf('#') != -1) {
            e.preventDefault();
            var url_split = url.split('#');
            // console.log('$$$$--'+ url_split[1]);
            if (url_split[1] != '') {
                $("html, body").animate({
                    scrollTop: $('#' + url_split[1]).offset().top - $('header').outerHeight()
                }, "slow");
            }
        }
    });

    /**
     * Detect OS & browsers
     */
    /* Add class for mac */
    if (navigator.appVersion.indexOf("Win") != -1) {
        jQuery('body').addClass('window-os');
    }
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
        jQuery('body').addClass('mac-os');
    }
    if (navigator.appVersion.indexOf("Linux") != -1) {
        jQuery('body').addClass('linux-os');
    }
    /* Add class for all ie version */
    var trident = !!navigator.userAgent.match(/Trident\/7.0/);
    var net = !!navigator.userAgent.match(/.NET4.0E/);
    var IE11 = trident && net;
    var IEold = (navigator.userAgent.match(/MSIE/i) ? true : false);
    if (IE11 || IEold) {
        jQuery('body').addClass('ie');
    }
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            jQuery('body').addClass('isChrome');
        } else {
            jQuery('body').addClass('isSafari');
        }
    }
    var FF = !(window.mozInnerScreenX == null);
    if (FF) {
        jQuery('body').addClass('fire-fox');
    } else {
        //jQuery('body').addClass('not-fire-fox');
    }
    /* End */

    //   $('body').on('click','.option-value.bundles-product',function(){
    //     $(this).parents('.option-values').find('.option-value-name').removeClass('selectedcol');
    //     $(this).find('.option-value-name').addClass('selectedcol');
    //   });

    $('body').on('change', '.collection_product__grid_new .product-variant-dropdown select[name="id"]', function() {
        var form = $(this).closest('form');
        var $this_current = $(this).find('option:selected');
        if ($this_current.attr('data-subscribe-hide') == 'true') {
            form.find('.repeat-btn.has_subscription').hide();
        } else {
            form.find('.repeat-btn.has_subscription .subscribe_price').text($this_current.attr('data-subscribe-price'));
            form.find('.repeat-btn.has_subscription').show();
        }
        form.find('.pg-btn .buy_once_price').text($this_current.attr('data-price'));
    });

});
$('body').on('click', '.product-details-wrapper .product-pack-list .pack_list-value', function(e) {
    e.preventDefault();
    $(this).closest('.product-form-grid-radio').find('.pack_list-value').removeClass('active_pack');
    $(this).addClass('active_pack').find('input').prop('checked', true);;
    var mprice = $(this).find('.packprice').attr('data-mprice');
    var cprice = $(this).find('.packprice').attr('data-cprice');
    if (mprice) {
        $('li.tab-slider--trigger.otp').find('.main_price').html('<span>' + cprice + '</span><del>' + mprice + '</del>');
        // $(this).parents('.tab-slider--trigger').find('.main_price').html('<span>'+cprice+'</span><del>'+mprice+'</del>');
        $(this).parents('.product-form-grid-radio').find('[data-product-submit]').find('.one-time').html('<span>' + cprice + '</span><del>' + mprice + '</del>'); //THE ONE
    } else {
        $('li.tab-slider--trigger.otp').find('.main_price').html('<span>' + cprice + '</span>');
        // $(this).parents('.tab-slider--trigger').find('.main_price').html('<span>'+cprice+'</span>');
        $(this).parents('.product-form-grid-radio').find('[data-product-submit]').find('.one-time').html('<span>' + cprice + '</span>'); //THE ONE
    }

    // $(this).closest('.product-card-interactions').find('[data-product-submit]').find('.one-time').html('<del>'+cprice+'</del><span>'+mprice+'</span>');
    if (parseInt($(this).find('input').val()) == 1) {
        $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').removeClass('unavailable_subscribe');
    } else {
        $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab2"]').addClass('unavailable_subscribe');
        $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab1"]').find('input#otpinpt').trigger('click');

        // $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab1"]').find('input').trigger('click');
        // $('.template-product').find('.product-form-grid-radio').find('.tab-slider--tabs').find('li[rel="tab1"]').trigger('click');
    }
});

$('body').on('click', '.product-card-interactions .product-pack-list .pack_list-value', function() {
    $(this).closest('.product-pack-list').find('.pack_list-value').removeClass('active_pack');
    $(this).addClass('active_pack');
    var mprice = $(this).find('.packprice').attr('data-mprice');
    var cprice = $(this).find('.packprice').attr('data-cprice');
    $(this).closest('.product-card-interactions').find('[data-product-submit]').find('.one-time').html('<del>' + cprice + '</del><span>' + mprice + '</span>');
});
$(window).bind("load", function() {
    setTimeout(function() { 
      $('#gorgias-chat-container').show();
    }, 10000 );
});

if ($('.marquee-slider-wrapper').length > 0) {
    $(function() {
        $('.marquee-slider-wrapper').slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: false,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            buttons: false
        });
    });
}
if($('#shopify-section-static-gift-collection-v2 .product-list').length > 0){
  $(function() {
    $('#shopify-section-static-gift-collection-v2 .product-list').slick({ 
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        buttons: false,
        responsive: [ {
          breakpoint: 767,
          settings: {
            // centerMode: true,
            // centerPadding: '60px',
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
          {
          breakpoint: 575,
          settings: {
            // centerMode: true,
            // centerPadding: '60px',
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          } 
        }]
     });
  });
}

$(document).ready(function() {
    if ($('.membership-product-slider').length > 0) {
        $(function() {
            $('.membership-product-slider').slick({
                infinite: false,
                centerMode: false,
                arrows: true,
                dots: false,
                autoplay: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                adaptiveHeight: true,
                responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                        }
                    }
                ]
            });
        });
    }
});
// $.fn.isOnScreen = function() {
// 		var win = $(window);
// 		var viewport = {
// 				top: win.scrollTop(),
// 				left: win.scrollLeft()
// 		};
// 		viewport.right = viewport.left + win.width();
// 		viewport.bottom = viewport.top + win.height();
// 		var bounds = this.offset();
// 		bounds.right = bounds.left + this.outerWidth();
// 		bounds.bottom = bounds.top + this.outerHeight();
// 		return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
// };

// $(window).scroll(function() {
// 		if ($('.stick-table-wrapper').isOnScreen()) {
// 				$('.stick-table-wrapper').addClass("active");
//                 $('.stick-table-wrapper tr').each(function(i) {
//                 (function(self) {
//                 setTimeout(function(i, e) {
//                 $(self).addClass('animation');
//                 },(i*700)+700);
//                 })(this);
//                 });
// 		} else {
// 				$('.stick-table-wrapper').removeClass("active");
//           $('.stick-table-wrapper tr').removeClass('animation');

// 		}
//       var theta = $(window).scrollTop() / 200 % Math.PI;
//       $('.sticky-scroll-img').css({ transform: 'rotate(' + theta + 'rad)' });
// });

function checkbtn() {
    function appendbtn() {
        if ($('#__next').length > 0) {
            var logoutBtn = $('<div class="C9q Shl zI7 iyn Hsu logout_btn"><div class="FNs zI7 iyn Hsu"><div class="XiG zI7 iyn Hsu" style="width: 100%;"><div class="zI7 iyn Hsu" style="opacity: 1; transition: opacity 0.25s ease 0s;"><div class="zI7 iyn Hsu"><button aria-label="Logout" type="button" tabindex="0" style="min-height: 47px; text-align: center; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; background: rgb(17, 17, 17); padding: 14px 20px; border-radius: 8px; outline: 0px; color: white; font-weight: bold; font-size: 14px; border: none;"><div class="Umk zI7 iyn Hsu"><div class="buttonTextColor"><svg class="Hn_ gUZ erh U9O kVc" height="16" width="16" viewBox="0 0 24 24" aria-label="Logout" role="img"><path d="M7.184 22.56a1.5 1.5 0 0 0-.002-2.121l-1.442-1.44 8.76-.003a1.5 1.5 0 1 0-.001-3l-8.755.003 1.437-1.44a1.5 1.5 0 1 0-2.123-2.118L0 17.508l5.063 5.054a1.5 1.5 0 0 0 2.121-.002m9.637-10.998a1.501 1.501 0 0 1-.002-2.121L18.256 8 9.5 8.005a1.5 1.5 0 0 1-.001-3L18.26 5l-1.442-1.44a1.494 1.494 0 0 1-.441-1.061 1.498 1.498 0 0 1 2.56-1.061L24 6.493l-5.058 5.067a1.5 1.5 0 0 1-2.121.002"></path></svg></div></div>Logout</button></div></div></div></div></div>')
            var item = $('<div class="C9q Shl zI7 iyn Hsu rewards_btn"><a href="/pages/rewards"><div class="FNs zI7 iyn Hsu"><div class="XiG zI7 iyn Hsu" style="width: 100%;"><div class="zI7 iyn Hsu" style="opacity: 1; transition: opacity 0.25s ease 0s;"><div class="zI7 iyn Hsu"><button aria-label="Order history" type="button" tabindex="0" style="min-height: 47px; text-align: center; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; background: rgb(17, 17, 17); padding: 14px 20px; border-radius: 8px; outline: 0px; color: white; font-weight: bold; font-size: 14px; border: none;">Rewards</button></div></div></div></a></div>');
            if ($('.rewards_btn').length == 0) {
                $('.F6l.Jea.Uex.XBe.hA-.k1A.kzZ.wYR.zI7.iyn.Hsu').append(item);
            }
            if ($('button[aria-label="Logout"]').length == 0) {
                $('.F6l.Jea.Uex.XBe.hA-.k1A.kzZ.wYR.zI7.iyn.Hsu').prepend(logoutBtn);
            }
        }
    }
    window.setInterval(appendbtn, 500);
}
$(window).on('load', function() {
    if (window.location.href.indexOf("a/account/subscriptions") > -1) {
        checkbtn();
    }
    if (window.location.href.indexOf("a/account/orders") > -1) {
        checkbtn();
    }
});


// $(window).on("load resize scroll",function(e){
//     // define the function here
//    if ($(window).width() < 767)
//    {
//       var sliderheight = $(".membership-product-slider .slick-current .product-inner figure img").height() / 2;
//      $(".membership-product-slider .slick-arrow").css("top", sliderheight);
//    }

// });   
// product dot height get
$(document).ready(function() {
    var sliderheightdot = $(".membership-product-slider .product-inner .product-card-figure").outerHeight();
    $(".membership-product-list-wrapper ul.slick-dots").css("top", sliderheightdot);
});

$(".main-header--nav-links .nav-item.has-mega-nav").hover(
    function() {
        $("header").addClass("result_hover");
    },
    function() {
        $("header").removeClass("result_hover");
    }
);

$('body').on('click', '.pdp_upsell_product .upsell_btn', function(e) {
    e.preventDefault();
    var _this0 = this;
    var variant_id = $(this).attr('data-variant');
    var qty = 1;
    var data = {
        quantity: qty,
        id: variant_id
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown) {
            var response = $.parseJSON(jqXHR.responseText);
            console.log(response);
        },
        success: function success(data) {
            _this0.cartMini.refresh();
            setTimeout(function() {
                _this0.cartMini.open();
            }, 100);
        }
    });
});

$(".sub-menu>li>a").click(function() {
    $(".sub-menu>li>a").removeClass("active");
    $(".sub-sub-menu_main").slideUp();
    if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("active");
    }
})


$('.menu-accoridian .mob_menu_tabs_list .tab_link').click(function() {
    var tab_id = $(this).attr('data-tab');
    $(this).closest('.mobile-nav').find('.menu-accoridian .mob_menu_tabs_list .tab_link').removeClass('current');
    $(this).closest('.mobile-nav').find('.menu-accoridian .menu-accoridian_tab_main .msubmenu').removeClass('current');
    $(this).addClass('current');
    $("#" + tab_id).addClass('current');
});

// mobile nav
function handleResize() {
    if ($(window).width() > 959) {
        $(".main-header").removeClass('opennav');
    }
}
$(window).on('resize', handleResize);
handleResize();
$('body').on('click', '.main-header-wrap .close-menu', function() {
    $(".main-header").removeClass('opennav');
});

$("body").on("click", ".main-div .read-more", function() {
    if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).parents(".main-div").find(".desc_collection").slideUp(300).removeClass("active");
    } else {
        $(this).addClass("active");
        $(this).parents(".main-div").find(".desc_collection").slideDown(300).addClass("active");
    }
});

// Create an array to store all swiper instances
const deskPopInstances = [];

// Initialize Swiper for each .desktop_popup_slider
$('.desktop_popup_slider').each(function(index, element) {
    const swiperInstance = new Swiper(element, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button-next.desktop_popup_arrow',
            prevEl: '.swiper-button-prev.desktop_popup_arrow',
        },
        pagination: {
            el: ".swiper-pagination.desktop_popup_pagination",
            clickable: true,
        },
    });

    // Store instance with reference to its DOM element
    deskPopInstances.push({
        element: element,
        instance: swiperInstance
    });
});

// variant change input
$('body').on('change', '.pdp_pack_list .pdp_pack_input', function(e) {
    const container_v = $('.pdp_hero_left_inner');
    const popupSlider_v = container_v.find('.desktop_popup_slider')[0]; // DOM element
    // Find the matching Swiper instance
    const match_v = deskPopInstances.find(item => item.element === popupSlider_v);

    if (match_v) {
        match_v.instance.update(); // Refresh Swiper layout
    } else {
        console.warn('No matching Swiper instance to update');
    }
    var variant_id = $(this).val();
    var pack_mprice = $(this).attr('data-price');
    var pack_count = $('.pdp_pack_option_input:checked').val();
    var cur_varaint = $(this).attr('data-var').toLowerCase().replace(/ /g, '-');

    $(".product-select[name=id]").val(variant_id);
    var data_qty_limit = parseInt($(".pdp_day_left").attr('data-qty-limit'));
    var cur_qty = $(".product-select[name=id]").find(':selected').attr('data-qty');
    var cur_qty_Sell = parseInt($(".product-select[name=id]").find(':selected').attr('data-out-sell'));
    if (cur_qty_Sell == 1) {
        $('.pdp_day_left').hide();
    } else if (cur_qty < data_qty_limit) {
        $('.pdp_day_left').show().find('.qty').text(cur_qty);
    } else {
        $('.pdp_day_left').hide();
    }
    if ($(this).hasClass('hideVariantSubscription')) {
        $('li.pdp_drop_slide_wpr.subscribe_save').addClass('hideVariant_ubscription');
        if ($('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save:not(.hideVariant_ubscription):not(.unavailable_subscribe) .pdp_drop_radio')) {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio').trigger('click');
        } else {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .pdp_drop_radio').trigger('click');
        }
        $('.subscription_text').text('Subscribe & Save Unavailable');
    } else {
        var per_amount = $('li.pdp_drop_slide_wpr.subscribe_save').attr('data-dv-per')
        $('.subscription_text').text('Subscribe & Save ' + per_amount + '%');
        $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio').trigger('click');
        $('li.pdp_drop_slide_wpr.subscribe_save').removeClass('hideVariant_ubscription');
        if ($('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save:not(.hideVariant_ubscription):not(.unavailable_subscribe) .pdp_drop_radio').length) {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .pdp_drop_radio').trigger('click');
        } else {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio').trigger('click');
        }
    }

    // variant slider

    variant_Desc(cur_varaint);

    // Pack price 
    if ($('.pdp_pack_option_col').length > 0) {
        $('.pdp_pack_option_col').each(function(i, v) {
            var $this = $(this);
            var pack = parseInt($(this).find('input').val());
            var percentage = parseInt($(this).find('input').attr('data-pv'));
            var mprice = pack_mprice * pack;
            if (percentage > 0) {
                var discounted = mprice * parseInt(percentage) / 100;
                var final = mprice - discounted;
                $this.attr('data-pack-dis-price', Shopify.formatMoney(final));
            }

            var sub_percentage = parseInt($('li.pdp_drop_slide_wpr.subscribe_save').attr('data-dv-per'));
            var sub_discounted = mprice * parseInt(sub_percentage) / 100;
            var sub_final = mprice - sub_discounted;

            $this.attr('data-sub-price', Shopify.formatMoney(sub_final));
            $this.attr('data-pack-price', Shopify.formatMoney(mprice));
            var m_price = Shopify.formatMoney(mprice);
            m_price = m_price.replace('$', '');
            m_price = parseFloat(m_price);
            var data_t = parseFloat($('.pdp_pack_option_wpr').attr('data-thresh'));

            if (m_price > data_t) {
                $(this).find('.pdp_pack_option_value').find('.pack_free_shipping').show();
            } else {
                $(this).find('.pdp_pack_option_value').find('.pack_free_shipping').hide();
            }
            if ($(this).find('.pdp_pack_option_value').find('.gummies_count').length > 0) {
                var $gummy = $(this).find('.pdp_pack_option_value').find('.gummies_count');
                var gPrice = parseFloat((final ? final : (m_price * 100)) / 100) / $gummy.data('gummies');
                gPrice = gPrice.toFixed(2);
                $(this).find('.pdp_pack_option_value').find('.gummies_count').text('$' + gPrice + ' / Gummy');
            }
        });

        // tab price and btn price
        var cur_pack_mprice = $('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').attr('data-pack-price');
        var cur_pack_disprice = $('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').attr('data-pack-dis-price');
        var data_sub_price = $('.pdp_pack_option_input:checked').parent('.pdp_pack_option_col').attr('data-sub-price');

        if (cur_pack_disprice) {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price').html('<span class="del_price">' + cur_pack_disprice + '</span><span class="price">' + cur_pack_mprice + '</span>');
            $('.add_to_cart_btn').find('span').text(cur_pack_mprice);
        } else {
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price').html('<span class="price">' + cur_pack_mprice + '</span>');
            $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .price_main').html('<span class="del_price">' + cur_pack_mprice + '</span><span class="price">' + data_sub_price + '</span>');
            $('.add_to_cart_btn').find('span').text(cur_pack_mprice);
            if ($('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once').find('.gummies_count').length > 0) {
                var $one_gummy = $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once').find('.gummies_count');
                var goPrice = parseFloat(cur_pack_mprice.replace('$', '')) / $one_gummy.data('gummies');
                goPrice = goPrice.toFixed(2);
                $('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once').find('.gummies_count').text('$' + goPrice + ' / Gummy');
            }
            if ($('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').find('.gummies_count').length > 0) {
                var $ss_gummy = $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').find('.gummies_count');
                var ssPrice = parseFloat(data_sub_price.replace('$', '')) / $ss_gummy.data('gummies');
                ssPrice = ssPrice.toFixed(2);
                $('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').find('.gummies_count').text('$' + ssPrice + ' / Gummy');
            }
        }
    } else {
        $('.add_to_cart_btn').find('span').text(Shopify.formatMoney(pack_mprice));
    }
    // URL update variant wise
    var newUrl = [window.location.protocol, '//', window.location.host, window.location.pathname, '?variant=', variant_id];
    if (Theme.utmString != '') {
        newUrl.push('&' + Theme.utmString);
    }
    var variantUrl = newUrl.join('');
    window.history.replaceState({
        path: variantUrl
    }, '', variantUrl);

    //Update The Pre-order Text Based on Variant
    if (typeof window.metadata[variant_id] != 'undefined' && window.metadata[variant_id].pre_order_text != '') {
        $('.pdp_pre_order .pre_order_text').text(window.metadata[variant_id].pre_order_text);
        $('.pdp_pre_order').show();
    } else {
        $('.pdp_pre_order').hide();
    }
});

$("body").on("click", ".new_desktop_slider .swiper-slide", function() {
    const container = $(".pdp_hero_left_inner");
    const popup = container.find(".pdp_desktop_popup");
    const popupSlider = $(this).parents('.pdp_gallery_wpr').find(".desktop_popup_slider")[0]; // DOM element
    const data_slide = parseInt($(this).attr('data-slide'), 10) || 0;

    // Open the popup
    popup.addClass("is-open");
    $("body").addClass("is-open");

    // Find the matching Swiper instance
    const match = deskPopInstances.find(item => {
        return item.element === popupSlider;
    });
    if (match) {
        if (data_slide > 0) {
            match.instance.slideTo(data_slide - 1);
        } else {
            match.instance.slideTo(data_slide);
        }
    }
});

function imginset() {
    if ($(window).width() > 768) {
        var headerHeight = $('.template--page-ways-to-save.product-grid-square .product-card-figure').outerHeight();
        $('.template--page-ways-to-save .membership-product-list-wrapper .slick-arrow')
            .css("top", (headerHeight / 2) + "px");
    } else {
        $('.template--page-ways-to-save .membership-product-list-wrapper .slick-arrow')
            .css("top", "");
    }
}
imginset();
$(window).on('load resize orientationchange', function() {
    imginset();
});


$("body").on("click", ".desk_close_icon, .desk_overlay_popup", function() {
    $(this).closest(".pdp_hero_left_inner").find(".pdp_desktop_popup").removeClass("is-open");
    $("body").removeClass("is-open");
});